import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Button,
   Box,
   Flex,
   HStack,
   Text,
   Menu,
   MenuButton,
   MenuList,
   MenuItem,
   Badge,
   TableContainer,
   Table,
   Thead,
   Tr,
   Th,
   Tbody,
   Td,
   Checkbox,
   Tooltip,
   useDisclosure,
   IconButton,
   Divider,
   Spacer,
   Icon,
   Input,
   Stack,
   useColorMode,
   VStack,
   Textarea,
   FormLabel,
   FormControl,
   Alert,
   AlertIcon,
   AlertTitle,
   AlertDescription,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { GrFormNext, GrFormPrevious } from 'react-icons/gr';
import { FaHistory, FaRegFilePdf, FaRupeeSign, FaWhatsappSquare } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useUser } from 'contexts';
import JsBarcode from 'jsbarcode';
import PrintBarcodeModal from '../../views/admin/utility/components/PrintBarcodeInfo';

import { getAccountById } from '../../redux/actions/account';

import { getSaleInvoicestransactions } from '../../redux/actions/salesInvoice';
import { getSaleReturnInvoicestransactions } from '../../redux/actions/salesReturnInvoice';
import { getPurchaseDocPdf, getPurchaseInvoicestransactions } from '../../redux/actions/purchaseInvoice';
import { getPurchaseReturnInvoicestransactions } from '../../redux/actions/purchaseReturnInvoice';
import { deleteAdjustedDocs } from '../../redux/actions/salesInvoice';
import LogView from 'components/salesDetails/LogView';
import { LockIcon } from '@chakra-ui/icons';

// image

import editIcon from '../../assets/img/nfts/edit.svg';
import printIcon from '../../assets/img/nfts/print.svg';
import dotIcon from '../../assets/img/nfts/dot.svg';
import dwonloadIcon from '../../assets/img/nfts/download.svg';
import receiptIcon from '../../assets/img/nfts/receipt.svg';
import { FiPrinter } from 'react-icons/fi';
import { MdGppBad, MdGppGood } from "react-icons/md";
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import recenttransactions from '../../assets/img/nfts/recent transactions.png';
import { getAdjustedDocs } from '../../redux/actions/salesInvoice';
import { getSetupFormat, setupFormatCustomQuery } from '../../redux/actions/setupFormat';
import jsPDF from 'jspdf';
import arial from '../../fonts/ARIAL.TTF';
import impact from '../../fonts/impact.ttf';
import helvetica from '../../fonts/Helvetica.ttf';
import times from '../../fonts/times.ttf';
import georgia from '../../fonts/georgia.ttf';
import verdanai from '../../fonts/VERDANAI.TTF';
import trebuc from '../../fonts/trebuc.ttf';
import courierPrime from '../../fonts/CourierPrime-Regular.ttf';
import anek from "../../fonts/AnekGujarati_Condensed-Regular.ttf";
import notoSerif from "../../fonts/NotoSerifGujarati-Regular.ttf";
import comic from '../../fonts/COMIC.TTF';
import { toast } from 'react-toastify';
import IssuePurchaseEntriesModal from 'components/IssuePurchaseEntries/IssuePurchaseEntries';
import { getPageWidth } from 'constants';
import { getPageHeight } from 'constants';
import about from 'assets/img/nfts/about.svg';
import { getWpSetting, sendWhatsAppMessage, sendWhatsAppPdf } from '../../redux/actions/settings';
import MobileNoForm from './MobileNo';
import { getDaybook } from '../../redux/actions/daybook';
import { addIssueReason } from '../../redux/actions/issueInventory';
import Swal from 'sweetalert2';
import { addReceiveReason } from '../../redux/actions/receiveInventory';
import { DeleteIcon } from '@chakra-ui/icons';
import { Download } from 'lucide-react';
import { partyServiceBlock } from '../../redux/actions/salesInvoice';

async function loadFontAsBase64(url) {
   const response = await fetch(url);
   const buffer = await response.arrayBuffer();
   let binary = '';
   const bytes = new Uint8Array(buffer);
   const chunkSize = 0x8000;
   for (let i = 0; i < bytes.length; i += chunkSize) {
      let chunk = bytes.subarray(i, i + chunkSize);
      binary += String.fromCharCode.apply(null, chunk);
   }
   return btoa(binary);
}

const SalesDetails = ({
   isOpen,
   onClose,
   title,
   handlePrevPage,
   handleNextPage,
   paginate,
   singleEntityRights,
   entityType,
   singleEntity,
   setIsOpenSingleView,
   setIsEditFormOpen,
   viewDetail,
   billTerms = [],
   lineItems = [],
   onDelete,
   handleSerchClose,
   handleViewSingleData,
   salesData,
   setShouldOpenModalForWpSettings,
   shouldOpenModalForWpSettings,
   setShouldOpenModalForCashBank,
   shouldOpenModalForCashBank,
   cashbankid,
}) => {
   const { user } = useUser();
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const dimension = '6*20 mm';
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [selectedBarcodeItems, setSelectedBarcodeItems] = useState([]);
   const [tableData, setTableData] = useState([]);
   const [localAccount, setLocalAccount] = useState(null);
   const [hoveredIndex, setHoveredIndex] = useState(null);
   const isCashBankAccesible = entityType === 'saleinvoice' || entityType === 'purchaseinvoice';
   const [items, setItems] = useState([]);
   const account = useSelector((state) => state?.account?.single);
   const saleInvoicesTransactions = useSelector((state) => state?.sales?.data);
   const SaleReturnInvoicestransactions = useSelector((state) => state?.salesReturnInvoice?.data);
   const PurchaseInvoicestransactions = useSelector((state) => state?.purchaseInvoice?.data);
   const PurchaseReturnInvoicestransactions = useSelector((state) => state?.purchaseReturnInvoice?.data);
   const adjustedDocs = useSelector((state) => state?.sales?.adjusted);
   const setupPrint = useSelector((state) => state.setupPrint.customQuery || []);
   const setupPrintSingle = useSelector((state) => state.setupPrint?.result || []);
   const [isDaybookDataLoaded, setIsDaybookDataLoaded] = useState(false);
   const DaybookData = useSelector((state) => state?.daybook?.list || []);
   const daybookId =
      salesData && salesData.daybookId !== undefined && salesData.daybookId !== null ? salesData.daybookId : null;
   const SalesId = salesData && salesData.id !== undefined && salesData.id !== null ? salesData.id : null;
   const DaybookMobile =
      salesData && salesData.accMobile !== undefined && salesData.accMobile !== null ? salesData.accMobile : null;
   const autoSendAttempted = useRef(false);
   // const [setupPrintData, setSetupPrintData] = useState(null);
   const calculateTotal = (qty, rate, discount) => {
      const total = qty * rate;
      const discountAmount = (total / 100) * discount;
      return total - discountAmount;
   };
   const Admin = user?.isAdmin;
   const [isGenerating, setIsGenerating] = useState(false);
   const [zoom, setZoom] = useState(1);
   const [selectedElement, setSelectedElement] = useState(null);
   const [isBlockOpen, setIsBlockOpen] = useState(false);
   const [selectedBlockData, setSelectedBlockData] = useState(null);
   const [blockDate, setBlockDate] = useState("");
   const [blockReason, setBlockReason] = useState("");
   // const [isPreviewOpen, setIsPreviewOpen] = useState(false);
   const [previewElements, setPreviewElements] = useState([]);
   const [selectedItem, setSelectedItem] = useState(null);
   const [lineDetailId, setLineDetailId] = useState(null);
   const [isNotesModalOpen, setIsNotesModalOpen] = useState(false);
   const [notes, setNotes] = useState('');
   const [isDownloading, setIsDownloading] = useState(false);
   const [reason, setReason] = useState('');
   const [returnDate, setReturnDate] = useState('');
   const [isIssuePurchaseModalOpen, setIsIssuePurchaseModalOpen] = useState(false);
   const [serialNo, setSerialNo] = useState(null);
   const companyId = Number(localStorage.getItem('companyId'));
   const cashReceiveRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.cashReceive
      : null;

   const cashPaymentRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.cashPayment
      : null;
   const bankReceiveRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.bankReceive
      : null;

   const bankPaymentRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.bankPayment
      : null;
   // Move this logic outside JSX, before the return statement
   const isSalesEntity = entityType === 'saleinvoice';
   const cashTxnType = isSalesEntity ? 'receive' : 'payment';
   const bankTxnType = isSalesEntity ? 'receive' : 'payment';

   // Check specific rights based on transaction type
   const hasCashRight = Admin || (cashTxnType === 'receive' ? cashReceiveRight?.add : cashPaymentRight?.add);

   const hasBankRight = Admin || (bankTxnType === 'receive' ? bankReceiveRight?.add : bankPaymentRight?.add);
   const setupFormat = useSelector((state) => state.setupPrint.list);
   const [isPrintBarcode, setIsPrintBarcode] = useState(false);
   const [formData, setFormData] = useState({});
   const [selectedFormat, setSelectedFormat] = useState(null);
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [isProcessingWp, setIsProcessingWp] = useState(false);
   const [isProcessingEmail, setIsProcessingEmail] = useState(false);
   const [viewSetupFormat, setViewSetupFormat] = useState({});
   const [focusIndex, setFocusIndex] = useState(null);
   const PrintRef = useRef(null);
   const setupFormatRef = useRef([]);
   const {
      isOpen: isViewSetupFormatModalOpen,
      onOpen: onViewOpenSetupFormatModal,
      onClose: onViewCloseSetupFormatModal,
   } = useDisclosure();
   const { isOpen: isShowLog, onOpen: onShowLog, onClose: onCloseLog } = useDisclosure();
   const { isOpen: isOpenReturn, onOpen: onOpenReturn, onClose: onCloseReturn } = useDisclosure();
   const { isOpen: isPreviewOpen, onOpen: onOpenPreview, onClose: onClosePreview } = useDisclosure();
   const [logId, setLogId] = useState(null);
   const handleCashPaymentClick = () => {
      if (viewDetail.accountId) {
         const isSalesEntity = entityType === 'saleinvoice';
         const txnType = isSalesEntity ? 'receive' : 'payment';
         navigate(`/admin/cash?method=cash&txn=${txnType}&accId=${viewDetail.accountId}`);
      } else {
         console.warn('Account ID is missing');
      }
   };
   const handleBankPaymentClick = () => {
      if (viewDetail.accountId) {
         const isPurchaseEntity = entityType === 'saleinvoice';
         const txnType = isPurchaseEntity ? 'receive' : 'payment';
         navigate(`/admin/bank?method=bank&txn=${txnType}&accId=${viewDetail.accountId}`);
      } else {
         console.warn('Account ID is missing');
      }
   };

   const removeadj = async (data) => {
      // dispatch(deleteAdjustedDocs(data.outAdjustmentId));
      const response = await dispatch(deleteAdjustedDocs(data.outAdjustmentId));
      if (response.code === 1 && user && singleEntity && entityType) {
         const typeMap = {
            saleinvoice: 'SALES',
            salereturn: 'SALES RETURN',
            purchaseinvoice: 'PURCHASE',
            purchasereturn: 'PURCHASE RETURN',
         };
         dispatch(
            getAdjustedDocs({
               companyId: user?.loginhistory?.companyId,
               spId: singleEntity.id,
               daybookId: singleEntity.daybookId,
               accountId: singleEntity.accountId,
               type: typeMap[entityType] || undefined,
            }),
         );
         console.log('typeMap', singleEntity.id);
      }
   };
   useEffect(() => {
      if (account) {
         setLocalAccount(account);
      }
   }, [account]);
   // Add this useEffect to handle the wpSettings condition
   useEffect(() => {
      if (!DaybookData || !Array.isArray(DaybookData) || !daybookId) {
         return;
      }

      // Find the specific daybook with matching ID
      const matchedDaybook = DaybookData.find((daybook) => Number(daybook.id) === Number(daybookId));

      if (matchedDaybook && matchedDaybook.wpSettings === 1) {
         console.log('Opening modal because wpSettings === 1');
         // setShouldOpenModalForWpSettings(true);
         // Open the modal
         // if (!isViewSetupFormatModalOpen) {
         //    onViewOpenSetupFormatModal(); // Assuming you have a function to open the modal
         // }
      }
   }, [DaybookData, daybookId, isViewSetupFormatModalOpen]);

   // useEffect(() => {
   //    dispatch(getDaybook({ companyId: user?.loginhistory?.companyId }));
   // }, [dispatch, user?.loginhistory?.companyId]);

   useEffect(() => {
      if (isViewSetupFormatModalOpen && Array.isArray(setupFormat) && setupFormat.length > 0) {
         const defaultFormat = setupFormat.find((format) => format.isDefault);
         if (defaultFormat && !selectedFormat) {
            setSelectedFormat(defaultFormat);
         }
      }
   }, [isViewSetupFormatModalOpen, setupFormat, selectedFormat]);

   useEffect(() => {
      if (shouldOpenModalForCashBank && Array.isArray(setupFormat) && setupFormat.length > 0) {
         const defaultFormat = setupFormat.find((format) => format.isDefault);
         if (defaultFormat && !selectedFormat) {
            setSelectedFormat(defaultFormat);
         }
      }
   }, [shouldOpenModalForCashBank, setupFormat, selectedFormat]);

   useEffect(() => {
      if (isViewSetupFormatModalOpen) {
         getSetupFormats();
      }
   }, [isViewSetupFormatModalOpen]);

   const executePrintMultiple = (barcodeItems) => {
      // Create a print window
      const printWindow = window.open('', '_blank', 'height=auto,width=auto');

      // Create the HTML content with a 2x2 grid layout
      let contentHTML = `
            <html>
          <head>
            <title>Barcode Labels</title>
            <style>
              @page {
                size: 30mm 11mm; /* Size for 4 labels */
                margin: 0;
                padding: 0;
  
              }
              body {
                margin: 0;
                padding: 0;
                display: flex;
                flex-wrap: wrap;
              }
              .label-container {
                width: 29mm;  //30mm - 30 size
                height: 7mm;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-top:-4px;
               // padding-bottom: 6px;
              }
              img {
                max-width: 40mm;  //25mm - 30 size
                max-height: 10mm;
                width: 110%;
                height: auto;
                margin-left: 0mm;  // cmt - 30 size
              }
            //   .label-container {
            //     width: 29mm;  //30mm - 30 size
            //     height: 11mm;
            //     display: flex;
            //     flex-direction: column;
            //     justify-content: center;
            //     align-items: center;
            //     margin-top:8px;
            //    // padding-bottom: 6px;
            //   }
            //   img {
            //     max-width: 24mm;  //25mm - 30 size
            //     max-height: 10mm;
            //     width: 100%;
            //     height: auto;
            //     margin-left: 2mm;  // cmt - 30 size
            //   }
              .serial-number {
                font-size: 5pt;  //4pt - 30 size
                text-align: center;
                // margin-left: 4mm;  // cmt - 30 size
              }
            </style>
          </head>
          <body>
       `;

      // Add each barcode label to the content
      barcodeItems.forEach((item, index) => {
         const paddingClass = index > 0 ? 'padding-bottom: "-8px";' : '';
         contentHTML += `
           <div class="label-container" style="${paddingClass}" >
             <img src="${item.barcodeDataUrl}" />
             <span class="serial-number">${item.barcode}</span>
           </div>
         `;
      });

      // Close the HTML content
      contentHTML += `
         </body>
         </html>
       `;

      // Write the content to the print window
      printWindow.document.write(contentHTML);
      printWindow.document.close();

      // Print after a short delay to ensure content is loaded
      setTimeout(() => {
         printWindow.print();
         setTimeout(() => {
            printWindow.close();
         }, 500);
      }, 300);
   };

   const handleBarcodePrint = () => {
      if (selectedBarcodeItems.length === 0) return;

      // Create SVG barcodes for each selected serial number
      const barcodeItems = selectedBarcodeItems.map((item) => {
         const svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

         JsBarcode(svgElement, item.serialNo.toString(), {
            format: 'CODE128',
            width: 1,
            height: 18,
            displayValue: true,
            fontSize: 0,
            marginTop: 10,
            textMargin: 0,
            xmlDocument: document,
         });

         const svgData = new XMLSerializer().serializeToString(svgElement);
         const barcodeDataUrl = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgData);

         return {
            serialNumber: item.serialNo,
            dimensions: dimension,
            barcode: item.barcode,
            barcodeDataUrl: barcodeDataUrl,
         };
      });

      // Update state with selected items
      setItems(barcodeItems);

      // Print selected barcodes
      executePrintMultiple(barcodeItems);
   };

   // Count total available barcode items
   const getTotalBarcodeItems = () => {
      if (!lineItems) return 0;

      return lineItems
         .filter(
            (item) =>
               item?.purchaseLineDetail && Array.isArray(item.purchaseLineDetail) && item.purchaseLineDetail.length > 0,
         )
         .flatMap((item) => item.purchaseLineDetail.filter((detail) => detail?.serialNo)).length;
   };

   // Check if an item is selected
   const isItemSelected = (serialNo) => {
      return selectedBarcodeItems.some((item) => item.id === serialNo);
   };

   const handleClose = () => {
      setSelectedBarcodeItems([]); // Clear the array
      onClose(); // Close the modal
      onCloserecenttransactions();
   };

   // Toggle individual selection
   const handleCheckboxChange = (itemId, serialNo, barcode, lineItemId, itemName) => {
      setSelectedBarcodeItems((prevSelected) => {
         const isItemSelected = prevSelected.some((item) => item.id === itemId);

         if (isItemSelected) {
            return prevSelected.filter((item) => item.id !== itemId);
         } else {
            return [
               ...prevSelected,
               {
                  id: itemId,
                  serialNo,
                  barcode,
                  lineItemId,
                  itemName,
               },
            ];
         }
      });
   };
   // onClick handler mein safely execute karo
   const handleClick = () => {
      try {
         setSelectedFormat && setSelectedFormat(null);
         if (shouldOpenModalForWpSettings) {
            setShouldOpenModalForWpSettings(false);
            onViewCloseSetupFormatModal();
            navigate('/admin/sales/invoice');
         }
         if (shouldOpenModalForCashBank) {
            setShouldOpenModalForCashBank(false);
            onViewCloseSetupFormatModal();
         }
         setShouldOpenModalForWpSettings && setShouldOpenModalForWpSettings(false);
         onViewCloseSetupFormatModal();
         // navigate('/admin/sales/invoice');
      } catch (error) {
         console.error('Error in form close:', error);
      }
   };
   const renderTableElement = (element, isPreview = false) => {
      const fields = element.tableFields || [];
      const rows = setupPrint || element.tableData || [];
      const totalWidth = element.width * (isPreview ? 1 : zoom);

      // Helper function to get border styles based on showBorders and showColumnLines
      const getBorderStyles = (isHeader = false, isLastRow = false, fieldIndex = 0, totalFields = 0) => {
         let borderStyles = {};

         if (element.showBorders) {
            // Original behavior: show all borders
            borderStyles = {
               border: `${fields[0]?.borderWidth || 1}px solid ${fields[0]?.borderColor || '#000000'}`,
            };
         }

         if (element.showColumnLines) {
            // New feature: show vertical column lines + header top/bottom + last row bottom
            borderStyles = {
               ...borderStyles,
               borderTop: 'none',
               borderBottom: 'none',
               borderLeft: 'none',
               borderRight: 'none',
            };

            // Vertical borders for all columns
            if (fieldIndex === 0) {
               // First column gets left border
               borderStyles.borderLeft = `${fields[0]?.borderWidth || 1}px solid ${fields[0]?.borderColor || '#000000'
                  }`;
            }
            // All columns get right border (creates vertical lines between columns)
            borderStyles.borderRight = `${fields[0]?.borderWidth || 1}px solid ${fields[0]?.borderColor || '#000000'}`;

            // Header gets top and bottom border
            if (isHeader) {
               borderStyles.borderTop = `${fields[0]?.borderWidth || 1}px solid ${fields[0]?.borderColor || '#000000'}`;
               borderStyles.borderBottom = `${fields[0]?.borderWidth || 1}px solid ${fields[0]?.borderColor || '#000000'
                  }`;
            }

            // Only last row gets bottom border
            if (isLastRow) {
               borderStyles.borderBottom = `${fields[0]?.borderWidth || 1}px solid ${fields[0]?.borderColor || '#000000'
                  }`;
            }

            // If both showBorders and showColumnLines are true, maintain outer table border
            if (element.showBorders) {
               // The table container will handle the outer border
            }
         }

         if (!element.showBorders && !element.showColumnLines) {
            borderStyles = { border: 'none' };
         }

         return borderStyles;
      };

      return (
         <TableContainer
            width={totalWidth}
            height={element.height * (isPreview ? 1 : zoom)}
            border={
               element.showBorders
                  ? `${fields[0]?.borderWidth || 1}px solid ${fields[0]?.borderColor || '#000000'}`
                  : 'none'
            }>
            <Table variant="simple" size="sm">
               <Thead>
                  <Tr>
                     {fields.map((field, fieldIndex) => (
                        <Th
                           key={field.id}
                           width={`${field.width}%`}
                           textAlign={field.alignment}
                           fontFamily={field.fontFamily || element.fontFamily || 'Arial'}
                           fontSize={`${element.headerStyle.fontSize * (isPreview ? 1 : zoom)}px`}
                           fontWeight={element.headerStyle.fontWeight}
                           color={element.headerStyle.color}
                           backgroundColor={element.headerStyle.backgroundColor}
                           padding={`${field.padding}px`}
                           {...getBorderStyles(true)}>
                           {field.label}
                        </Th>
                     ))}
                  </Tr>
               </Thead>
               <Tbody>
                  {rows.map((row, rowIndex) => {
                     const isLastRow = rowIndex === rows.length - 1;

                     return (
                        <Tr
                           key={row.id}
                           backgroundColor={
                              element.alternateRowColors
                                 ? rowIndex % 2 === 0
                                    ? element.evenRowColor
                                    : element.oddRowColor
                                 : element.evenRowColor
                           }>
                           {fields.map((field, fieldIndex) => (
                              <Td
                                 key={field.id}
                                 textAlign={field.alignment}
                                 fontSize={`${field.fontSize * (isPreview ? 1 : zoom)}px`}
                                 fontWeight={field.fontWeight}
                                 fontFamily={field.fontFamily || element.fontFamily || 'Arial'}
                                 color={field.color}
                                 backgroundColor={field.backgroundColor}
                                 padding={`${field.padding}px`}
                                 {...getBorderStyles(false, isLastRow, fieldIndex, fields.length)}>
                                 {isPreview ? <Text>{row[field.id] || field.placeholder}</Text> : null}
                              </Td>
                           ))}
                        </Tr>
                     );
                  })}
               </Tbody>
            </Table>
         </TableContainer>
      );
   };
   const renderElement = (element, isPreview = false) => {
      const isSelected = !isPreview && selectedElement && selectedElement.id === element.id;

      // Special handling for image elements
      if (element.type === 'image') {
         const imageStyle = {
            position: 'absolute',
            left: element.x * (isPreview ? 1 : zoom),
            top: element.y * (isPreview ? 1 : zoom),
            width: element.width * (isPreview ? 1 : zoom),
            height: element.height * (isPreview ? 1 : zoom),
            cursor: isPreview ? 'default' : 'move',
            border: isSelected ? '2px solid #3B82F6' : '1px solid #E5E7EB',
            backgroundColor: element.backgroundColor || '#F9FAFB',
            borderRadius: element.borderRadius || 0,
            opacity: element.opacity || 1,
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
         };

         return (
            <Box key={element.id} style={imageStyle} userSelect="none" position="relative">
               {element.src ? (
                  <img
                     src={element.src}
                     alt={element.alt || 'Image'}
                     style={{
                        width: '100%',
                        height: '100%',
                        objectFit: element.objectFit || 'contain',
                        borderRadius: element.borderRadius || 0,
                     }}
                  />
               ) : null}
            </Box>
         );
      }

      if (element.type === 'barcode') {
         const barcodeStyle = {
            position: 'absolute',
            left: element.x * (isPreview ? 1 : zoom),
            top: element.y * (isPreview ? 1 : zoom),
            width: element.width * (isPreview ? 1 : zoom),
            height: element.height * (isPreview ? 1 : zoom),
            cursor: isPreview ? 'default' : 'move',
            border: isSelected ? '2px solid #3B82F6' : '1px solid #E5E7EB',
            backgroundColor: element.backgroundColor || '#FFFFFF',
            borderRadius: element.borderRadius || 0,
            opacity: element.opacity || 1,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
         };

         // Generate proper barcode using JsBarcode (similar to handleBarcodePrint)
         const generateBarcodeDataUrl = (value) => {
            try {
               const barcodeValue = value || element.barcodeValue || element.content || '123456789012';
               const svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

               // Configure JsBarcode options similar to your handleBarcodePrint
               JsBarcode(svgElement, barcodeValue.toString(), {
                  format: element.barcodeFormat || 'CODE128',
                  width: element.barWidth || 1,
                  height: element.barHeight || 18,
                  displayValue: element.showText !== false,
                  fontSize: element.fontSize || 0,
                  marginTop: element.marginTop || 10,
                  textMargin: element.textMargin || 0,
                  xmlDocument: document,
                  background: element.backgroundColor || '#FFFFFF',
                  lineColor: element.foregroundColor || '#000000',
               });

               const svgData = new XMLSerializer().serializeToString(svgElement);
               return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgData);
            } catch (error) {
               console.error('Error generating barcode:', error);
               return null;
            }
         };

         const barcodeDataUrl = generateBarcodeDataUrl(element.content);

         return (
            <Box key={element.id} style={barcodeStyle} userSelect="none" position="relative">
               {barcodeDataUrl ? (
                  <img
                     src={barcodeDataUrl}
                     alt={`Barcode: ${element.content || element.barcodeValue || '123456789012'}`}
                     style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                     }}
                  />
               ) : (
                  // Fallback display if barcode generation fails
                  <Box
                     display="flex"
                     alignItems="center"
                     justifyContent="center"
                     height="100%"
                     fontFamily="monospace"
                     fontSize={`${(element.fontSize || 12) * (isPreview ? 1 : zoom)}px`}
                     color={element.foregroundColor || '#000000'}>
                     {element.content || element.barcodeValue || '123456789012'}
                  </Box>
               )}
            </Box>
         );
      }

      // Special handling for line elements
      if (element.type === 'line') {
         const lineStyle = {
            position: 'absolute',
            left: element.x * (isPreview ? 1 : zoom),
            top: element.y * (isPreview ? 1 : zoom),
            width: element.width * (isPreview ? 1 : zoom),
            height: element.height * (isPreview ? 1 : zoom),
            cursor: isPreview ? 'default' : 'move',
            border: isSelected ? '2px solid #3B82F6' : '1px solid transparent',
            backgroundColor: isSelected ? 'rgba(59, 130, 246, 0.1)' : element.backgroundColor || 'transparent',
            minHeight: isPreview ? element.height : Math.max(element.height, 10),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
         };

         return (
            <Box key={element.id} style={lineStyle} userSelect="none" position="relative">
               <Box
                  w="100%"
                  h={`${element.thickness || element.height}px`}
                  bg={element.color || '#000000'}
                  style={{
                     transform: element.rotation ? `rotate(${element.rotation}deg)` : 'none',
                     transformOrigin: 'center center',
                  }}
               />
            </Box>
         );
      }

      // FIXED: Determine proper whiteSpace and wordWrap behavior
      const getTextWrapStyle = () => {
         // If wordWrap is set to 'break-word', allow wrapping
         if (element.wordWrap === 'break-word') {
            return {
               whiteSpace: 'pre-wrap', // Allow wrapping and preserve line breaks
               wordWrap: 'break-word',
               wordBreak: 'break-word', // Additional CSS property for better wrapping
               overflow: 'visible',
            };
         }

         // For specific element types that should wrap by default
         if (element.type === 'client' || element.type === 'notes') {
            return {
               whiteSpace: 'pre-wrap',
               wordWrap: 'normal',
               overflow: 'visible',
            };
         }

         // For custom whiteSpace settings
         if (element.whiteSpace === 'pre-wrap') {
            return {
               whiteSpace: 'pre-wrap',
               wordWrap: element.wordWrap || 'normal',
               overflow: 'visible',
            };
         }

         // Default behavior - no wrapping
         return {
            whiteSpace: element.whiteSpace || 'nowrap',
            wordWrap: element.wordWrap || 'normal',
            overflow: 'hidden',
         };
      };
      const getVerticalAlignStyle = () => {
         const verticalAlign = element.verticalAlign || 'top';

         switch (verticalAlign) {
            case 'middle':
               return {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent:
                     element.textAlign === 'center'
                        ? 'center'
                        : element.textAlign === 'right'
                           ? 'flex-end'
                           : 'flex-start',
               };
            case 'bottom':
               return {
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent:
                     element.textAlign === 'center'
                        ? 'center'
                        : element.textAlign === 'right'
                           ? 'flex-end'
                           : 'flex-start',
               };
            case 'top':
            default:
               return {
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent:
                     element.textAlign === 'center'
                        ? 'center'
                        : element.textAlign === 'right'
                           ? 'flex-end'
                           : 'flex-start',
               };
         }
      };
      const textWrapStyle = getTextWrapStyle();
      const verticalAlignStyle = getVerticalAlignStyle();

      let key = element.id;

      if (element.type === 'text') {
         element.content = setupPrintSingle[0][key] ? setupPrintSingle[0][key] : element.content;
      } else if (element.type === 'field') {
         element.content = setupPrintSingle[0][key] ? setupPrintSingle[0][key] : element.content;
      } else {
         element.content = setupPrintSingle[0][key] ? setupPrintSingle[0][key] : element.content;
      }

      // Regular element styling for other elements
      const elementStyle = {
         position: 'absolute',
         left: element.x * (isPreview ? 1 : zoom),
         top: element.y * (isPreview ? 1 : zoom),
         width: element.width * (isPreview ? 1 : zoom),
         height: element.height * (isPreview ? 1 : zoom),
         fontSize: element.fontSize * (isPreview ? 1 : zoom),
         fontWeight: element.fontWeight || 'normal',
         fontStyle: element.fontStyle || 'normal',
         fontFamily: element.fontFamily || 'Arial',
         color: element.color || '#000000',
         textAlign: element.textAlign || 'left',
         textDecoration: element.textDecoration || 'none',
         border: isSelected ? '2px solid #3B82F6' : '1px solid transparent',
         cursor: isPreview ? 'default' : 'move',
         // FIXED: Apply proper text wrapping styles
         ...textWrapStyle,
         ...verticalAlignStyle,
         backgroundColor: element.backgroundColor || 'transparent',
         borderColor: element.borderColor || 'transparent',
         borderWidth: element.borderWidth || 0,
         borderStyle: element.borderStyle || 'solid',
         borderRadius: element.borderRadius || 0,
         padding: element.padding || '4px',
         opacity: element.opacity || 1,
         textTransform: element.textTransform || 'none',
         lineHeight: element.lineHeight || 1.2,
         letterSpacing: `${element.letterSpacing || 0}px`,
         boxShadow: isSelected ? 'inset 0 0 0 2px rgba(59, 130, 246, 0.1)' : 'none',
      };

      return (
         <Box key={element.id} style={elementStyle} userSelect="none" position="relative">
            {element.type === 'table' ? renderTableElement(element, isPreview) : <Box>{element.content}</Box>}
         </Box>
      );
   };

   // Updated helper functions
   // const getPageWidth = (pageData) => {
   //    let { pageSize, orientation, customWidth } = pageData;

   //    if (orientation === undefined) {
   //       orientation = 'potrait';
   //    }
   //    if (customWidth === undefined) {
   //       customWidth = 595;
   //    }
   //    let width;
   //    switch (pageSize) {
   //       case 'a3':
   //          width = 842; // A3 width in pixels at 72dpi
   //          break;
   //       case 'a4':
   //          width = 595; // A4 width
   //          break;
   //       case 'a5':
   //          width = 420; // A5 width
   //          break;
   //       case 'custom':
   //          width = customWidth;
   //          break;
   //       default:
   //          width = 595;
   //    }

   //    // For landscape, swap width and height for predefined sizes
   //    if (orientation === 'landscape' && pageSize !== 'custom') {
   //       const height = getPageHeight({ ...pageData, orientation: 'portrait' });
   //       return height;
   //    }

   //    return width;
   // };

   // const getPageHeight = (pageData) => {
   //    let { pageSize, orientation, customHeight } = pageData;
   //    if (customHeight === undefined) {
   //       customHeight = 842;
   //    }
   //    let height;
   //    switch (pageSize) {
   //       case 'a3':
   //          height = 1191; // A3 height
   //          break;
   //       case 'a4':
   //          height = 842; // A4 height
   //          break;
   //       case 'a5':
   //          height = 595; // A5 height
   //          break;
   //       case 'custom':
   //          height = customHeight;
   //          break;
   //       default:
   //          height = 842;
   //    }

   //    // For landscape, swap width and height for predefined sizes
   //    if (orientation === 'landscape' && pageSize !== 'custom') {
   //       const width = getPageWidth({ ...pageData, orientation: 'portrait' });
   //       return width;
   //    }

   //    return height;
   // };

   //Printer Function Starts
   const printDocument = async (selectedFormat) => {
      setIsGenerating(true);
      try {
         const targetPrinterName = selectedFormat.printerName; // "Canon LBP"

         // Check if we can access printer APIs
         const canAccessPrinters = await checkPrinterAPISupport();

         if (canAccessPrinters) {
            // Use modern printer API
            await printWithPrinterAPI(selectedFormat, targetPrinterName);
         } else {
            // Fallback to direct print without printer detection
            await printDirectly(selectedFormat, targetPrinterName);
         }
      } catch (error) {
         console.error('Print failed:', error);
         toast({
            title: 'Print Failed',
            description: error.message || 'Failed to print document. Please try again.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      } finally {
         setIsGenerating(false);
      }
   };

   // Check if printer APIs are supported and accessible
   const checkPrinterAPISupport = async () => {
      try {
         // Check for modern print API support
         if ('getAvailablePrinters' in window || ('navigator' in window && 'printing' in navigator)) {
            return true;
         }

         // Check if we're in a secure context (HTTPS)
         if (!window.isSecureContext) {
            console.warn('Printer API requires HTTPS connection');
            return false;
         }

         return false;
      } catch (error) {
         console.error('Printer API check failed:', error);
         return false;
      }
   };

   // Print using modern printer API (if available)
   const printWithPrinterAPI = async (selectedFormat, targetPrinterName) => {
      try {
         // Request printer access
         const printers = (await navigator.printing?.getPrinters?.()) || [];

         // Find matching printer
         let selectedPrinter = printers.find((printer) =>
            printer.name.toLowerCase().includes(targetPrinterName.toLowerCase()),
         );

         if (!selectedPrinter && printers.length > 0) {
            // Use first available printer as fallback
            selectedPrinter = printers[0];
            toast({
               title: 'Printer Notice',
               description: `Using ${selectedPrinter.name} instead of ${targetPrinterName}`,
               status: 'info',
               duration: 3000,
               isClosable: true,
            });
         }

         if (selectedPrinter) {
            await generateAndPrint(selectedFormat, selectedPrinter.name);
         } else {
            throw new Error('No printers available');
         }
      } catch (error) {
         console.error('Printer API failed:', error);
         // Fallback to direct print
         await printDirectly(selectedFormat, targetPrinterName);
      }
   };

   // Direct print without printer detection (most reliable)
   const printDirectly = async (selectedFormat, targetPrinterName) => {
      try {
         toast({
            title: 'Preparing Print',
            description: `Preparing document for ${targetPrinterName}...`,
            status: 'info',
            duration: 2000,
            isClosable: true,
         });

         await generateAndPrint(selectedFormat, targetPrinterName);
      } catch (error) {
         throw new Error(`Failed to prepare print: ${error.message}`);
      }
   };

   // Generate content and execute print
   const generateAndPrint = async (selectedFormat, printerName) => {
      try {
         // Get the data using your existing function
         const result = await dispatch(
            setupFormatCustomQuery({
               query: selectedFormat?.PrintFormat?.query,
               entityId: singleEntity.id.toString(),
            }),
         );

         if (!result || !result?.data || result?.data?.length === 0) {
            throw new Error('No data available for printing');
         }

         const html = selectedFormat?.PrintFormat?.html || [];
         const parsedElements = JSON.parse(html);

         // Create print content
         const printContent = createPrintableHTML(parsedElements);

         // Execute print
         await executePrint(printContent, printerName, selectedFormat.functionName);

         toast({
            title: 'Print Sent',
            description: `Document sent to ${printerName}`,
            status: 'success',
            duration: 3000,
            isClosable: true,
         });
      } catch (error) {
         throw new Error(`Print generation failed: ${error.message}`);
      }
   };

   // Create printable HTML content
   const createPrintableHTML = (parsedElements) => {
      let printHTML = '';

      // Sort elements by z-index or order for proper layering
      const sortedElements = parsedElements.elements.sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0));

      sortedElements.forEach((element) => {
         if (element.type === 'table') {
            printHTML += createTableHTML(element);
         } else if (element.type === 'image') {
            printHTML += createImageHTML(element);
         } else if (element.type === 'line') {
            printHTML += createLineHTML(element);
         } else {
            printHTML += createTextHTML(element);
         }
      });

      return printHTML;
   };

   // Create table HTML for printing
   const createTableHTML = (element) => {
      const fields = element.tableFields || [];
      const rows = setupPrintSingle || [];

      if (fields.length === 0) return '';

      let tableHTML = `
      <table style="
         width: 100%; 
         border-collapse: collapse; 
         margin: ${element.y || 0}px 0 20px ${element.x || 0}px;
         page-break-inside: avoid;
      ">
         <thead>
            <tr style="background-color: #f8f9fa;">
   `;

      fields.forEach((field) => {
         tableHTML += `
         <th style="
            border: 1px solid #333; 
            padding: 8px; 
            font-size: ${element.headerStyle?.fontSize || 12}px;
            font-weight: ${element.headerStyle?.fontWeight || 'bold'};
            width: ${field.width}%;
            text-align: center;
         ">
            ${field.label || ''}
         </th>
      `;
      });

      tableHTML += '</tr></thead><tbody>';

      rows.forEach((row, rowIndex) => {
         const bgColor = element.alternateRowColors && rowIndex % 2 === 1 ? '#f9f9f9' : 'white';
         tableHTML += `<tr style="background-color: ${bgColor}; page-break-inside: avoid;">`;

         fields.forEach((field) => {
            const cellValue = row[field.id] || field.placeholder || '';
            tableHTML += `
            <td style="
               border: 1px solid #333; 
               padding: ${field.padding || 4}px; 
               font-size: ${field.fontSize || 10}px;
               font-weight: ${field.fontWeight || 'normal'};
               text-align: ${field.alignment || 'left'};
               vertical-align: top;
            ">
               ${String(cellValue).replace(/\n/g, '<br>')}
            </td>
         `;
         });

         tableHTML += '</tr>';
      });

      tableHTML += '</tbody></table>';
      return tableHTML;
   };

   // Create image HTML for printing
   const createImageHTML = (element) => {
      if (!element.src) return '';

      return `
      <img src="${element.src}" style="
         position: absolute;
         left: ${element.x || 0}px;
         top: ${element.y || 0}px;
         width: ${element.width || 'auto'}px;
         height: ${element.height || 'auto'}px;
         object-fit: ${element.objectFit || 'contain'};
      " alt="Image" />
   `;
   };

   // Create line HTML for printing
   const createLineHTML = (element) => {
      const isVertical = element.rotation === 90 || element.rotation === -90;

      return `
      <div style="
         position: absolute;
         left: ${element.x || 0}px;
         top: ${element.y || 0}px;
         width: ${isVertical ? element.thickness || 1 : element.width || 100}px;
         height: ${isVertical ? element.width || 100 : element.thickness || 1}px;
         background-color: ${element.color || '#000'};
         transform: rotate(${element.rotation || 0}deg);
      "></div>
   `;
   };

   // Create text HTML for printing
   const createTextHTML = (element) => {
      const content = element.content || '';
      if (!content) return '';

      return `
      <div style="
         position: absolute;
         left: ${element.x || 0}px;
         top: ${element.y || 0}px;
         width: ${element.width || 'auto'}px;
         height: ${element.height || 'auto'}px;
         font-size: ${element.fontSize || 12}px;
         color: ${element.color || '#000'};
         background-color: ${element.backgroundColor || 'transparent'};
         text-align: ${element.textAlign || 'left'};
         font-weight: ${element.fontWeight || 'normal'};
         line-height: ${element.lineHeight || 1.2};
         padding: ${element.padding || 0}px;
         border: ${element.borderWidth || 0}px solid ${element.borderColor || '#000'};
         word-wrap: ${element.wordWrap || 'normal'};
         white-space: ${element.whiteSpace || 'normal'};
      ">
         ${String(content).replace(/\n/g, '<br>')}
      </div>
   `;
   };

   // Execute the actual print
   const executePrint = async (content, printerName, documentTitle) => {
      return new Promise((resolve, reject) => {
         try {
            // Create print window
            const printWindow = window.open('', '_blank', 'width=800,height=600');

            if (!printWindow) {
               reject(new Error('Failed to open print window. Please allow popups.'));
               return;
            }

            const printDocument = printWindow.document;

            printDocument.write(`
            <!DOCTYPE html>
            <html>
            <head>
               <title>${documentTitle || 'Print Document'}</title>
               <meta charset="utf-8">
               <style>
                  @page { 
                     size: A4 portrait; 
                     margin: 0.5in; 
                  }
                  body { 
                     font-family: Arial, sans-serif; 
                     margin: 0; 
                     padding: 0; 
                     background: white;
                     -webkit-print-color-adjust: exact;
                     print-color-adjust: exact;
                  }
                  .print-content {
                     position: relative;
                     width: 100%;
                     min-height: 100vh;
                  }
                  @media screen {
                     body { background: #f5f5f5; padding: 20px; }
                     .print-content { background: white; padding: 20px; box-shadow: 0 0 10px rgba(0,0,0,0.1); }
                  }
                  @media print {
                     body { background: white; }
                     .no-print { display: none !important; }
                     .print-content { padding: 0; margin: 0; }
                  }
               </style>
            </head>
            <body>
               <div class="no-print" style="text-align: center; padding: 10px; background: #e3f2fd; margin-bottom: 20px;">
                  <strong>Target Printer: ${printerName}</strong><br>
                  <small>Click Ctrl+P to print or close this window to cancel</small>
               </div>
               <div class="print-content">
                  ${content}
               </div>
               <script>
                  window.onload = function() {
                     // Auto-print after a short delay
                     setTimeout(function() {
                        window.print();
                        // Close window after print dialog
                        setTimeout(function() {
                           window.close();
                        }, 1000);
                     }, 500);
                  };
                  
                  // Handle print events
                  window.onbeforeprint = function() {
                     console.log('Printing to: ${printerName}');
                  };
                  
                  window.onafterprint = function() {
                     console.log('Print completed');
                     setTimeout(function() {
                        window.close();
                     }, 1000);
                  };
               </script>
            </body>
            </html>
         `);

            printDocument.close();

            // Resolve after print window is created
            setTimeout(() => {
               resolve();
            }, 1000);
         } catch (error) {
            reject(new Error(`Print execution failed: ${error.message}`));
         }
      });
   };

   const mapFontFamily = (fontFamily) => {
      const fontMap = {
         arial: 'helvetica',
         'sans-serif': 'helvetica',
         impact: 'helvetica', // Impact falls back to helvetica
         'times new roman': 'times',
         serif: 'times',
         'courier new': 'courier',
         monospace: 'courier',
      };

      const lowerFont = fontFamily.toLowerCase();
      return fontMap[lowerFont] || 'helvetica';
   };

   // with word wrap
   const generatePDF = async (preElements, result, action = 'export') => {
      setIsGenerating(true);
      const pElements = preElements.elements ? preElements : previewElements;
      // Get page dimensions from previewElements
      const pageWidth = getPageWidth(pElements);
      const pageHeight = getPageHeight(pElements);

      // Determine orientation for jsPDF
      const orientation = pElements.orientation === 'landscape' ? 'l' : 'p';

      // Create custom page format
      const pageFormat = [pageWidth, pageHeight];
      try {
         // const doc = new jsPDF('p', 'pt', 'a4');
         const doc = new jsPDF(orientation, 'pt', pageFormat);

         const arialBase64 = await loadFontAsBase64(arial);
         const impactBase64 = await loadFontAsBase64(impact);
         const helveticaBase64 = await loadFontAsBase64(helvetica);
         const timesBase64 = await loadFontAsBase64(times);
         const georgiaBase64 = await loadFontAsBase64(georgia);
         const verdanaiBase64 = await loadFontAsBase64(verdanai);
         const trebucBase64 = await loadFontAsBase64(trebuc);
         const courierPrimeBase64 = await loadFontAsBase64(courierPrime);
         const AnekBase64 = await loadFontAsBase64(anek);
         const NotoSerifBase64 = await loadFontAsBase64(notoSerif);
         const comicBase64 = await loadFontAsBase64(comic);

         doc.addFileToVFS('ARIAL.TTF', arialBase64);
         doc.addFont('ARIAL.TTF', 'arial', 'normal');

         doc.addFileToVFS('Impact.ttf', impactBase64);
         doc.addFont('Impact.ttf', 'impact', 'normal');

         doc.addFileToVFS('Helvetica.ttf', helveticaBase64);
         doc.addFont('Helvetica.ttf', 'helvetica', 'normal');

         doc.addFileToVFS('times.ttf', timesBase64);
         doc.addFont('times.ttf', 'times', 'normal');

         doc.addFileToVFS('georgia.ttf', georgiaBase64);
         doc.addFont('georgia.ttf', 'georgia', 'normal');

         doc.addFileToVFS('VERDANAI.TTF', verdanaiBase64);
         doc.addFont('VERDANAI.TTF', 'verdana', 'normal');

         doc.addFileToVFS('trebuc.ttf', trebucBase64);
         doc.addFont('trebuc.ttf', 'trebuchet ms', 'normal');

         doc.addFileToVFS('CourierPrime-Regular.ttf', courierPrimeBase64);
         doc.addFont('CourierPrime-Regular.ttf', 'courier new', 'normal');

         doc.addFileToVFS("AnekGujarati_Condensed-Regular.ttf", AnekBase64);
         doc.addFont("AnekGujarati_Condensed-Regular.ttf", "anek gujarati", "normal");

         doc.addFileToVFS("NotoSerifGujarati-Regular.ttf", NotoSerifBase64);
         doc.addFont("NotoSerifGujarati-Regular.ttf", "noto serif", "normal");

         doc.addFileToVFS('COMIC.TTF', comicBase64);
         doc.addFont('COMIC.TTF', 'comic sans ms', 'normal');

         // Process non-table elements first
         const nonTableElements = pElements.elements.filter((el) => el.type !== 'table');
         const tableElements = pElements.elements.filter((el) => el.type === 'table');

         // Helper function to determine text wrapping behavior
         const getTextWrapBehavior = (element) => {
            // If wordWrap is set to 'break-word', allow wrapping
            if (element.wordWrap === 'break-word') {
               return {
                  shouldWrap: true,
                  preserveLineBreaks: true,
                  breakWords: true,
               };
            }
            // For specific element types that should wrap by default
            if (element.type === 'client' || element.type === 'notes') {
               return {
                  shouldWrap: true,
                  preserveLineBreaks: true,
                  breakWords: false,
               };
            }
            // For custom whiteSpace settings
            if (element.whiteSpace === 'pre-wrap') {
               return {
                  shouldWrap: true,
                  preserveLineBreaks: true,
                  breakWords: element.wordWrap === 'break-word',
               };
            }
            // Default behavior - no wrapping
            return {
               shouldWrap: false,
               preserveLineBreaks: false,
               breakWords: false,
            };
         };

         // Helper function to wrap text for PDF
         const wrapText = (text, maxWidth, fontSize, fontStyle = 'normal', fontFamily = 'helvetica') => {
            doc.setFontSize(fontSize);
            doc.setFont(fontFamily, 'normal');
            // doc.setFont(undefined, fontStyle);
            const lines = [];
            const paragraphs = text.split('\n');
            paragraphs.forEach((paragraph) => {
               if (paragraph.trim() === '') {
                  lines.push('');
                  return;
               }
               const words = paragraph.split(' ');
               let currentLine = '';
               words.forEach((word) => {
                  const testLine = currentLine + (currentLine ? ' ' : '') + word;
                  const testWidth = doc.getTextWidth(testLine);
                  if (testWidth <= maxWidth) {
                     currentLine = testLine;
                  } else {
                     if (currentLine) {
                        lines.push(currentLine);
                        currentLine = word;
                     } else {
                        // Word is too long, break it
                        lines.push(word);
                     }
                  }
               });
               if (currentLine) {
                  lines.push(currentLine);
               }
            });
            return lines;
         };

         // Function to render all non-table elements
         const renderStaticContent = (pageNum = 1) => {
            nonTableElements.forEach((element) => {
               const x = element.x;
               const y = element.y;
               const fontSize = element.fontSize;
               const fontFamily = element.fontFamily || 'arial';

               doc.setFontSize(fontSize);
               doc.setTextColor(element.color);

               // const fontFamily = mapFontFamily(element.fontFamily || 'helvetica');
               const fontWeight = element.fontWeight === 'bold' ? 'bold' : 'normal';
               const fontStyle = element.fontStyle === 'italic' ? 'italic' : 'normal';
               let combinedStyle = fontWeight;
               if (fontStyle === 'italic') {
                  combinedStyle = fontWeight === 'bold' ? 'bolditalic' : 'italic';
               }
               doc.setFont(fontFamily, 'normal');

               // Handle different element types (image, line, text)
               if (element.type === 'image' && element.src) {
                  try {
                     let imageData = element.src;
                     if (element.src.startsWith('data:')) {
                        imageData = element.src;
                     }

                     const imgProps = doc.getImageProperties(imageData);
                     const pdfWidth = element.width;
                     const pdfHeight = element.height;

                     let finalWidth = pdfWidth;
                     let finalHeight = pdfHeight;
                     let offsetX = 0;
                     let offsetY = 0;

                     if (element.objectFit === 'contain') {
                        const imgRatio = imgProps.width / imgProps.height;
                        const containerRatio = pdfWidth / pdfHeight;

                        if (imgRatio > containerRatio) {
                           finalHeight = pdfWidth / imgRatio;
                           offsetY = (pdfHeight - finalHeight) / 2;
                        } else {
                           finalWidth = pdfHeight * imgRatio;
                           offsetX = (pdfWidth - finalWidth) / 2;
                        }
                     } else if (element.objectFit === 'cover') {
                        const imgRatio = imgProps.width / imgProps.height;
                        const containerRatio = pdfWidth / pdfHeight;

                        if (imgRatio > containerRatio) {
                           finalWidth = pdfHeight * imgRatio;
                           offsetX = (pdfWidth - finalWidth) / 2;
                        } else {
                           finalHeight = pdfWidth / imgRatio;
                           offsetY = (pdfHeight - finalHeight) / 2;
                        }
                     }

                     if (element.backgroundColor && element.backgroundColor !== 'transparent') {
                        const [bgR, bgG, bgB] = hexToRgb(element.backgroundColor);
                        doc.setFillColor(bgR, bgG, bgB);
                        doc.rect(x, y, pdfWidth, pdfHeight, 'F');
                     }

                     if (element.borderWidth > 0) {
                        const [borderR, borderG, borderB] = hexToRgb(element.borderColor || '#000000');
                        doc.setDrawColor(borderR, borderG, borderB);
                        doc.setLineWidth(element.borderWidth);

                        if (element.borderStyle === 'dashed') {
                           doc.setLineDash([3, 3]);
                        } else if (element.borderStyle === 'dotted') {
                           doc.setLineDash([1, 1]);
                        } else {
                           doc.setLineDash([]);
                        }

                        if (element.borderRadius > 0) {
                           doc.roundedRect(x, y, pdfWidth, pdfHeight, element.borderRadius, element.borderRadius, 'S');
                        } else {
                           doc.rect(x, y, pdfWidth, pdfHeight, 'S');
                        }
                     }

                     let imageFormat = 'JPEG';
                     if (imageData.includes('data:image/png')) {
                        imageFormat = 'PNG';
                     } else if (imageData.includes('data:image/gif')) {
                        imageFormat = 'GIF';
                     } else if (imageData.includes('data:image/webp')) {
                        imageFormat = 'WEBP';
                     }

                     doc.addImage(
                        imageData,
                        imageFormat,
                        x + offsetX,
                        y + offsetY,
                        finalWidth,
                        finalHeight,
                        undefined,
                        'FAST',
                        element.rotation || 0,
                     );

                     if (element.overlay) {
                        const [overlayR, overlayG, overlayB] = hexToRgb(element.overlay.color || '#000000');
                        doc.setFillColor(overlayR, overlayG, overlayB);
                        doc.setGState(new doc.GState({ opacity: element.overlay.opacity || 0.5 }));
                        doc.rect(x, y, pdfWidth, pdfHeight, 'F');
                        doc.setGState(new doc.GState({ opacity: 1 }));
                     }
                  } catch (error) {
                     console.error('Error adding image to PDF:', error);
                     const [placeholderR, placeholderG, placeholderB] = hexToRgb('#f5f5f5');
                     doc.setFillColor(placeholderR, placeholderG, placeholderB);
                     doc.rect(x, y, element.width, element.height, 'F');
                     doc.setDrawColor(200, 200, 200);
                     doc.setLineWidth(1);
                     doc.rect(x, y, element.width, element.height, 'S');
                     doc.setDrawColor(150, 150, 150);
                     doc.setLineWidth(2);
                     doc.line(x + 10, y + 10, x + element.width - 10, y + element.height - 10);
                     doc.line(x + element.width - 10, y + 10, x + 10, y + element.height - 10);
                     doc.setFontSize(10);
                     doc.setTextColor(128, 128, 128);
                     doc.text('Image not available', x + 10, y + element.height / 2);
                  }
               } else if (element.type === 'line') {
                  const [lineR, lineG, lineB] = hexToRgb(element.color || '#000000');
                  doc.setDrawColor(lineR, lineG, lineB);
                  doc.setLineWidth(element.thickness || element.height || 1);

                  if (element.rotation) {
                     // For rotated lines, we need to calculate the end points
                     const radians = (element.rotation * Math.PI) / 180;

                     // Adjust starting point for vertical lines (90 degrees)
                     let startX = x;
                     let startY = y;

                     if (Math.abs(element.rotation) === 90) {
                        // For vertical lines, start from width/2 offset
                        startX = x + element.width / 2;
                     }

                     const endX = startX + element.width * Math.cos(radians);
                     const endY = startY + element.width * Math.sin(radians);
                     doc.line(startX, startY, endX, endY);
                  } else {
                     // Horizontal line
                     doc.line(x, y + element.height / 2, x + element.width, y + element.height / 2);
                  }
               } else if (element.type === 'barcode') {
                  try {
                     // Generate barcode using canvas instead of SVG
                     const generateBarcodeCanvas = (value, options = {}) => {
                        try {
                           const barcodeValue = value || '123456789012';
                           const canvas = document.createElement('canvas');
                           const ctx = canvas.getContext('2d');

                           // Set canvas dimensions based on element size
                           canvas.width = options.width || 200;
                           canvas.height = options.height || 60;

                           // Configure JsBarcode to render on canvas
                           JsBarcode(canvas, barcodeValue.toString(), {
                              format: options.format || 'CODE128',
                              width: options.barWidth || 1,
                              height: options.barHeight || 40,
                              displayValue: options.showText !== false,
                              fontSize: options.fontSize || 10,
                              marginTop: options.marginTop || 0,
                              textMargin: options.textMargin || 0,
                              background: options.backgroundColor || '#FFFFFF',
                              lineColor: options.foregroundColor || '#000000',
                           });

                           // Convert canvas to data URL (PNG format)
                           return canvas.toDataURL('image/png');
                        } catch (error) {
                           console.error('Error generating barcode canvas:', error);
                           return null;
                        }
                     };

                     // Calculate barcode dimensions
                     const barcodeHeight = element.barHeight || 40;
                     const textHeight = element.showText !== false ? (element.fontSize || 10) + 10 : 0;
                     const totalBarcodeHeight = barcodeHeight + textHeight;

                     // Generate barcode with proper options
                     const barcodeDataURL = generateBarcodeCanvas(
                        setupPrintSingle[0][element.id] || element.barcodeValue || element.content,
                        {
                           width: element.width,
                           height: totalBarcodeHeight,
                           format: element.barcodeFormat || 'CODE128',
                           barWidth: element.barWidth || 1,
                           barHeight: barcodeHeight,
                           foregroundColor: element.foregroundColor || '#000000',
                           backgroundColor: element.backgroundColor || '#FFFFFF',
                           showText: element.showText !== false,
                           fontSize: element.fontSize || 10,
                           marginTop: element.marginTop || 0,
                           textMargin: element.textMargin || 0,
                        },
                     );

                     if (!barcodeDataURL) {
                        throw new Error('Failed to generate barcode');
                     }

                     // Add background if specified
                     if (element.backgroundColor && element.backgroundColor !== 'transparent') {
                        const [bgR, bgG, bgB] = hexToRgb(element.backgroundColor);
                        doc.setFillColor(bgR, bgG, bgB);
                        doc.rect(x, y, element.width, element.height, 'F');
                     }

                     // Add border if specified
                     if (element.borderWidth > 0) {
                        const [borderR, borderG, borderB] = hexToRgb(element.borderColor || '#000000');
                        doc.setDrawColor(borderR, borderG, borderB);
                        doc.setLineWidth(element.borderWidth);

                        if (element.borderStyle === 'dashed') {
                           doc.setLineDash([3, 3]);
                        } else if (element.borderStyle === 'dotted') {
                           doc.setLineDash([1, 1]);
                        } else {
                           doc.setLineDash([]);
                        }

                        if (element.borderRadius > 0) {
                           doc.roundedRect(
                              x,
                              y,
                              element.width,
                              element.height,
                              element.borderRadius,
                              element.borderRadius,
                              'S',
                           );
                        } else {
                           doc.rect(x, y, element.width, element.height, 'S');
                        }
                     }

                     // Center the barcode vertically within the element
                     let barcodeY = y;
                     if (element.height > totalBarcodeHeight) {
                        barcodeY = y + (element.height - totalBarcodeHeight) / 2;
                     }

                     // Add the barcode image to PDF using PNG format
                     doc.addImage(
                        barcodeDataURL,
                        'PNG',
                        x,
                        barcodeY,
                        element.width,
                        totalBarcodeHeight,
                        undefined,
                        'FAST',
                     );
                  } catch (error) {
                     console.error('Error adding barcode to PDF:', error);

                     // Fallback: draw placeholder rectangle with text
                     const [placeholderR, placeholderG, placeholderB] = hexToRgb('#f5f5f5');
                     doc.setFillColor(placeholderR, placeholderG, placeholderB);
                     doc.rect(x, y, element.width, element.height, 'F');
                     doc.setDrawColor(200, 200, 200);
                     doc.setLineWidth(1);
                     doc.rect(x, y, element.width, element.height, 'S');

                     // Add placeholder text
                     doc.setFontSize(10);
                     doc.setTextColor(128, 128, 128);
                     const barcodeText =
                        setupPrintSingle[0]['barcodevalue'] ||
                        element.barcodeValue ||
                        element.content ||
                        'Barcode Error';
                     doc.text(barcodeText, x + element.width / 2, y + element.height / 2, { align: 'center' });
                  }
               } else {
                  // Handle text elements with enhanced wrapping
                  if (element.backgroundColor && element.backgroundColor !== 'transparent') {
                     const [textBgR, textBgG, textBgB] = hexToRgb(element.backgroundColor);
                     doc.setFillColor(textBgR, textBgG, textBgB);
                     doc.rect(x, y, element.width, element.height, 'F');
                  }

                  if (element.borderWidth > 0) {
                     const [textBorderR, textBorderG, textBorderB] = hexToRgb(element.borderColor || '#000000');
                     doc.setDrawColor(textBorderR, textBorderG, textBorderB);
                     doc.setLineWidth(element.borderWidth);

                     if (element.borderStyle === 'dashed') {
                        doc.setLineDash([3, 3]);
                     } else if (element.borderStyle === 'dotted') {
                        doc.setLineDash([1, 1]);
                     } else {
                        doc.setLineDash([]);
                     }

                     if (element.borderRadius > 0) {
                        doc.roundedRect(
                           x,
                           y,
                           element.width,
                           element.height,
                           element.borderRadius,
                           element.borderRadius,
                           'S',
                        );
                     } else {
                        doc.rect(x, y, element.width, element.height, 'S');
                     }
                  }

                  doc.setFontSize(fontSize);
                  const fontStyle = element.fontWeight === 'bold' ? 'bold' : 'normal';
                  const fontFamily = element.fontFamily || 'arial';
                  if (fontFamily === 'Impact') {
                     doc.setFont(fontFamily, 'normal');
                  }
                  doc.setFont(fontFamily, 'normal');
                  // doc.setFont(undefined, fontStyle);

                  const [textR, textG, textB] = hexToRgb(element.color || '#000000');
                  doc.setTextColor(textR, textG, textB);

                  const lineHeight = element.lineHeight || 1.2;
                  const actualLineHeight = fontSize * lineHeight;

                  // Get text wrapping behavior
                  const wrapBehavior = getTextWrapBehavior(element);
                  const contentString =
                     element.content !== null && element.content !== undefined ? String(element.content) : '';
                  let lines;
                  if (wrapBehavior.shouldWrap) {
                     // Calculate available width for text
                     const availableWidth = element.width - (element.padding || 0) * 2;
                     lines = wrapText(contentString, availableWidth, fontSize, fontFamily);
                  } else {
                     // Use original line splitting for non-wrapping elements
                     // lines = element.content.split('\n');
                     lines = contentString.split('\n');
                  }
                  // Calculate vertical alignment offset
                  const totalTextHeight = lines.length * actualLineHeight;
                  const availableHeight = element.height - (element.padding || 0) * 2;
                  let verticalOffset = 0;

                  switch (element.verticalAlign) {
                     case 'top':
                        verticalOffset = 0;
                        break;
                     case 'middle':
                        verticalOffset = Math.max(0, (availableHeight - totalTextHeight) / 2);
                        break;
                     case 'bottom':
                        verticalOffset = Math.max(0, availableHeight - totalTextHeight);
                        break;
                     case 'baseline':
                        // For baseline, align to the baseline of the first line
                        verticalOffset = 0;
                        break;
                     default:
                        // Default to top alignment
                        verticalOffset = 0;
                        break;
                  }

                  lines.forEach((line, index) => {
                     let textX = x + (element.padding || 0);
                     let textOptions = {};

                     let displayText = line;
                     if (element.textTransform === 'uppercase') {
                        displayText = line.toUpperCase();
                     } else if (element.textTransform === 'lowercase') {
                        displayText = line.toLowerCase();
                     } else if (element.textTransform === 'capitalize') {
                        displayText = line.charAt(0).toUpperCase() + line.slice(1);
                     }

                     if (element.textAlign === 'center') {
                        textX = x + element.width / 2;
                        textOptions.align = 'center';
                     } else if (element.textAlign === 'right') {
                        textX = x + element.width - (element.padding || 0);
                        textOptions.align = 'right';
                     }

                     if (element.letterSpacing && element.letterSpacing !== 0) {
                        textOptions.charSpace = element.letterSpacing;
                     }

                     // const textY = y + (element.padding || 0) + index * actualLineHeight + fontSize;
                     const textY = y + (element.padding || 0) + verticalOffset + index * actualLineHeight + fontSize;
                     doc.setFont(fontFamily, 'normal');
                     doc.text(displayText, textX, textY, textOptions);
                  });
               }
            });
         };

         // Function to render table with pagination
         const renderTableWithPagination = async (element) => {
            const x = element.x;
            const y = element.y;
            const fields = element.tableFields;
            const rows = result || setupPrintSingle || setupPrint || [];
            const rowHeight = 20;
            const headerHeight = 20;

            const fontFamily = element.fontFamily || 'arial';

            // Calculate dynamic row heights for pagination
            const calculateRowHeights = (rows) => {
               return rows.map((row) => {
                  const cellHeights = fields.map((field) => {
                     const cellValue = row[field.id] || field.placeholder;
                     const textValue = cellValue !== null && cellValue !== undefined ? String(cellValue) : '';

                     // Split text by \n to handle line breaks
                     const lines = textValue.split('\n');
                     const lineHeight = field.fontSize * 1.2;

                     // Calculate wrapped lines for each line
                     const fieldWidth = (element.width * field.width) / 100;
                     const maxWidth = fieldWidth - field.padding * 2;

                     let totalLines = 0;
                     lines.forEach((line) => {
                        // Use jsPDF's splitTextToSize to get accurate line count
                        doc.setFontSize(field.fontSize);
                        const wrappedLines = doc.splitTextToSize(line, maxWidth);
                        totalLines += wrappedLines.length;
                     });

                     return Math.max(rowHeight, totalLines * lineHeight + field.padding * 2);
                  });

                  return {
                     row,
                     height: Math.max(...cellHeights),
                  };
               });
            };

            // Calculate row heights for all rows
            const rowsWithHeights = calculateRowHeights(rows);

            // Split rows into pages based on available height
            const availableHeight = element.height - headerHeight;
            const pageGroups = [];
            let currentPageRows = [];
            let currentPageHeight = 0;

            rowsWithHeights.forEach((rowInfo) => {
               if (currentPageHeight + rowInfo.height > availableHeight && currentPageRows.length > 0) {
                  // Current row doesn't fit, start new page
                  pageGroups.push(currentPageRows);
                  currentPageRows = [rowInfo];
                  currentPageHeight = rowInfo.height;
               } else {
                  currentPageRows.push(rowInfo);
                  currentPageHeight += rowInfo.height;
               }
            });

            // Add remaining rows
            if (currentPageRows.length > 0) {
               pageGroups.push(currentPageRows);
            }

            const totalPages = pageGroups.length;

            for (let pageIndex = 0; pageIndex < totalPages; pageIndex++) {
               if (pageIndex > 0) {
                  // Add new page for additional table content
                  doc.addPage();
                  // Render static content on new page
                  renderStaticContent(pageIndex + 1);
               }

               const currentPageRowsData = pageGroups[pageIndex];
               const currentPageRows = currentPageRowsData.map((rowInfo) => rowInfo.row);

               // Set drawing properties for table borders
               doc.setDrawColor(0, 0, 0);
               doc.setLineWidth(1);

               let currentY = y;

               // Draw headers on each page
               let currentX = x;
               fields.forEach((field) => {
                  const fieldWidth = (element.width * field.width) / 100;
                  const fontFamily = field.fontFamily || element.fontFamily || 'arial';
                  const fontStyle = field.fontStyle || element.fontStyle || 'normal';

                  doc.setFontSize(element.headerStyle.fontSize);
                  doc.setFont(fontFamily, 'normal');

                  doc.setFillColor(248, 249, 250);
                  doc.rect(currentX, currentY, fieldWidth, headerHeight, 'FD');

                  doc.setTextColor(0, 0, 0);
                  doc.text(field.label, currentX + field.padding, currentY + 15);
                  currentX += fieldWidth;
               });

               currentY += headerHeight;

               // Calculate dynamic row heights based on content
               const rowData = currentPageRows
                  .map((row, rowIndex) => {
                     return currentPageRowsData.find((rowInfo) => rowInfo.row === row);
                  })
                  .map((rowInfo, rowIndex) => {
                     const { row, height: dynamicRowHeight } = rowInfo;

                     const cellHeights = fields.map((field) => {
                        const cellValue = row[field.id] || field.placeholder;
                        const textValue = cellValue !== null && cellValue !== undefined ? String(cellValue) : '';

                        // Split text by \n to handle line breaks
                        const lines = textValue.split('\n');
                        const lineHeight = field.fontSize * 1.2; // Line height factor

                        return {
                           lines,
                           height: dynamicRowHeight,
                           lineHeight: lineHeight,
                        };
                     });

                     return {
                        row,
                        rowIndex,
                        height: dynamicRowHeight,
                        cellData: cellHeights,
                     };
                  });

               // Draw current page rows with dynamic heights
               rowData.forEach((rowInfo) => {
                  const { row, rowIndex, height: dynamicRowHeight, cellData } = rowInfo;

                  currentX = x;
                  fields.forEach((field, fieldIndex) => {
                     const fieldWidth = (element.width * field.width) / 100;
                     const fontFamily = field.fontFamily || element.fontFamily || 'arial';
                     const fontStyle = field.fontFamily || element.fontStyle || 'normal';

                     doc.setFontSize(field.fontSize);
                     doc.setFont(fontFamily, 'normal');

                     // Draw cell background
                     if (element.alternateRowColors && rowIndex % 2 === 1) {
                        doc.setFillColor(245, 245, 245);
                        doc.rect(currentX, currentY, fieldWidth, dynamicRowHeight, 'FD');
                     } else {
                        doc.setFillColor(255, 255, 255);
                        doc.rect(currentX, currentY, fieldWidth, dynamicRowHeight, 'FD');
                     }

                     doc.setTextColor(0, 0, 0);

                     // Get cell data for this field
                     const cellInfo = cellData[fieldIndex];
                     const { lines, lineHeight } = cellInfo;

                     // Calculate text position
                     let textX = currentX + field.padding;
                     if (field.alignment === 'center') {
                        textX = currentX + fieldWidth / 2;
                     } else if (field.alignment === 'right') {
                        textX = currentX + fieldWidth - field.padding;
                     }

                     // Track current Y position for proper line spacing
                     let currentLineY = currentY + field.padding + field.fontSize;

                     // Draw each line of text with proper spacing
                     lines.forEach((line, lineIndex) => {
                        // Handle text wrapping if line is too long
                        const maxWidth = fieldWidth - field.padding * 2;
                        const wrappedLines = doc.splitTextToSize(line, maxWidth);

                        wrappedLines.forEach((wrappedLine, wrappedIndex) => {
                           doc.text(wrappedLine, textX, currentLineY, {
                              align:
                                 field.alignment === 'center'
                                    ? 'center'
                                    : field.alignment === 'right'
                                       ? 'right'
                                       : 'left',
                              maxWidth: maxWidth,
                           });

                           // Move to next line position
                           currentLineY += lineHeight;
                        });
                     });

                     currentX += fieldWidth;
                  });
                  currentY += dynamicRowHeight;
               });

               // Draw outer table border with actual used height
               const actualTableHeight = headerHeight + rowData.reduce((sum, rowInfo) => sum + rowInfo.height, 0);
               doc.setDrawColor(0, 0, 0);
               doc.setLineWidth(1);
               doc.rect(x, y, element.width, actualTableHeight, 'S');

               if (element.showColumnLines) {
                  let columnX = x;
                  fields.forEach((field, fieldIndex) => {
                     if (fieldIndex < fields.length - 1) {
                        // Don't draw line after last column
                        const fieldWidth = (element.width * field.width) / 100;
                        columnX += fieldWidth;

                        // Draw vertical line for the column
                        doc.setDrawColor(
                           field.borderColor ? hexToRgb(field.borderColor)[0] : 226,
                           field.borderColor ? hexToRgb(field.borderColor)[1] : 232,
                           field.borderColor ? hexToRgb(field.borderColor)[2] : 240,
                        );
                        doc.setLineWidth(field.borderWidth || 1);
                        doc.line(columnX, y, columnX, y + actualTableHeight);
                     }
                  });
               }

               // Add page number if multiple pages
               if (totalPages > 1) {
                  doc.setFontSize(10);
                  doc.setTextColor(128, 128, 128);
                  doc.text(
                     `Page ${pageIndex + 1} of ${totalPages}`,
                     x + element.width - 50,
                     y + actualTableHeight + 15,
                  );
               }
            }
         };

         renderStaticContent(1);

         tableElements.forEach((element) => {
            if (element.type === 'table' && element.tableFields) {
               renderTableWithPagination(element);
            }
         });

         if (action === 'print') {
            const pdfBlob = doc.output('blob');
            // const pdfUrl = URL.createObjectURL(pdfBlob);

            // const printWindow = window.open(pdfUrl, '_blank');

            // if (printWindow) {
            //    printWindow.onload = () => {
            //       printWindow.print();
            //       // Optional: Close window after print dialog appears
            //       // setTimeout(() => printWindow.close(), 1000);
            //    };
            // }

            // Alternative: Create iframe for printing
            printPDFWithIframe(pdfBlob);
         } else {
            doc.save('invoice-format.pdf');
         }
         const actionText = action === 'print' ? 'sent to printer' : 'exported';
         toast({
            title: action === 'print' ? 'Print Ready' : 'PDF Generated',
            description: `Invoice format has been ${actionText} successfully!`,
            status: 'success',
            duration: 3000,
            isClosable: true,
         });
      } catch (error) {
         console.error(`${action.toUpperCase()} failed:`, error);
         toast({
            title: action === 'print' ? 'Print Failed' : 'Export Failed',
            description: `Failed to ${action} document. Please try again.`,
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      } finally {
         setIsGenerating(false);
      }
   };

   const printPDFWithIframe = (pdfBlob) => {
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = pdfUrl;

      document.body.appendChild(iframe);

      iframe.onload = () => {
         setTimeout(() => {
            iframe.contentWindow?.print();
            // Clean up after printing
            // setTimeout(() => {
            //    document.body.removeChild(iframe);
            //    URL.revokeObjectURL(pdfUrl);
            // }, 1000);
         }, 500);
      };
   };

   const generatePDFBlob = async (previewElements) => {
      setIsGenerating(true);

      // Check if previewElements is an empty array or undefined
      if (!previewElements || (Array.isArray(previewElements) && previewElements.length === 0)) {
         console.error('ERROR: previewElements is empty or undefined');
         setIsGenerating(false);
         throw new Error('No preview elements available. Please create a document first.');
      }

      // Handle case where previewElements might be an array instead of object
      let elements = [];
      let pageConfig = {};

      if (Array.isArray(previewElements)) {
         // If previewElements is an array, use it directly as elements
         elements = previewElements;
         pageConfig = {
            pageWidth: 595, // Default A4 width
            pageHeight: 842, // Default A4 height
            orientation: 'portrait',
         };
      } else if (previewElements.elements && Array.isArray(previewElements.elements)) {
         // If previewElements is an object with elements array
         elements = previewElements.elements;
         pageConfig = {
            pageWidth: previewElements.pageWidth || 595,
            pageHeight: previewElements.pageHeight || 842,
            orientation: previewElements.orientation || 'portrait',
         };
      } else {
         console.error('ERROR: previewElements has invalid format:', previewElements);
         setIsGenerating(false);
         throw new Error('Preview elements are not properly formatted');
      }

      // Check if we have any elements to render
      if (elements.length === 0) {
         console.error('ERROR: No elements to render');
         setIsGenerating(false);
         throw new Error('No content to generate PDF. Please add elements to your document.');
      }

      // Get page dimensions
      const pageWidth = pageConfig.pageWidth;
      const pageHeight = pageConfig.pageHeight;

      // Determine orientation for jsPDF
      const orientation = pageConfig.orientation === 'landscape' ? 'l' : 'p';

      // Create custom page format
      const pageFormat = [pageWidth, pageHeight];
      try {
         // const doc = new jsPDF('p', 'pt', 'a4');
         const doc = new jsPDF(orientation, 'pt', pageFormat);

         // Process non-table elements first with safe filtering
         const nonTableElements = elements.filter((el) => el && el.type !== 'table');
         const tableElements = elements.filter((el) => el && el.type === 'table');

         // If no elements to render, create a simple PDF
         if (nonTableElements.length === 0 && tableElements.length === 0) {
            doc.setFontSize(16);
            doc.text('No content available', 20, 20);
            return doc.output('blob');
         }

         // Helper function to determine text wrapping behavior
         const getTextWrapBehavior = (element) => {
            // If wordWrap is set to 'break-word', allow wrapping
            if (element.wordWrap === 'break-word') {
               return {
                  shouldWrap: true,
                  preserveLineBreaks: true,
                  breakWords: true,
               };
            }
            // For specific element types that should wrap by default
            if (element.type === 'client' || element.type === 'notes') {
               return {
                  shouldWrap: true,
                  preserveLineBreaks: true,
                  breakWords: false,
               };
            }
            // For custom whiteSpace settings
            if (element.whiteSpace === 'pre-wrap') {
               return {
                  shouldWrap: true,
                  preserveLineBreaks: true,
                  breakWords: element.wordWrap === 'break-word',
               };
            }
            // Default behavior - no wrapping
            return {
               shouldWrap: false,
               preserveLineBreaks: false,
               breakWords: false,
            };
         };

         // Helper function to wrap text for PDF
         const wrapText = (text, maxWidth, fontSize, fontStyle = 'normal') => {
            doc.setFontSize(fontSize);
            doc.setFont(undefined, fontStyle);
            const lines = [];
            const paragraphs = text.split('\n');
            paragraphs.forEach((paragraph) => {
               if (paragraph.trim() === '') {
                  lines.push('');
                  return;
               }
               const words = paragraph.split(' ');
               let currentLine = '';
               words.forEach((word) => {
                  const testLine = currentLine + (currentLine ? ' ' : '') + word;
                  const testWidth = doc.getTextWidth(testLine);
                  if (testWidth <= maxWidth) {
                     currentLine = testLine;
                  } else {
                     if (currentLine) {
                        lines.push(currentLine);
                        currentLine = word;
                     } else {
                        // Word is too long, break it
                        lines.push(word);
                     }
                  }
               });
               if (currentLine) {
                  lines.push(currentLine);
               }
            });
            return lines;
         };

         // Function to render all non-table elements
         const renderStaticContent = (pageNum = 1) => {
            nonTableElements.forEach((element) => {
               const x = element.x;
               const y = element.y;
               const fontSize = element.fontSize;

               doc.setFontSize(fontSize);
               doc.setTextColor(element.color);

               if (element.fontWeight === 'bold') {
                  doc.setFont(undefined, 'bold');
               } else {
                  doc.setFont(undefined, 'normal');
               }

               // Handle different element types (image, line, text)
               if (element.type === 'image' && element.src) {
                  try {
                     let imageData = element.src;
                     if (element.src.startsWith('data:')) {
                        imageData = element.src;
                     }

                     const imgProps = doc.getImageProperties(imageData);
                     const pdfWidth = element.width;
                     const pdfHeight = element.height;

                     let finalWidth = pdfWidth;
                     let finalHeight = pdfHeight;
                     let offsetX = 0;
                     let offsetY = 0;

                     if (element.objectFit === 'contain') {
                        const imgRatio = imgProps.width / imgProps.height;
                        const containerRatio = pdfWidth / pdfHeight;

                        if (imgRatio > containerRatio) {
                           finalHeight = pdfWidth / imgRatio;
                           offsetY = (pdfHeight - finalHeight) / 2;
                        } else {
                           finalWidth = pdfHeight * imgRatio;
                           offsetX = (pdfWidth - finalWidth) / 2;
                        }
                     } else if (element.objectFit === 'cover') {
                        const imgRatio = imgProps.width / imgProps.height;
                        const containerRatio = pdfWidth / pdfHeight;

                        if (imgRatio > containerRatio) {
                           finalWidth = pdfHeight * imgRatio;
                           offsetX = (pdfWidth - finalWidth) / 2;
                        } else {
                           finalHeight = pdfWidth / imgRatio;
                           offsetY = (pdfHeight - finalHeight) / 2;
                        }
                     }

                     if (element.backgroundColor && element.backgroundColor !== 'transparent') {
                        const [bgR, bgG, bgB] = hexToRgb(element.backgroundColor);
                        doc.setFillColor(bgR, bgG, bgB);
                        doc.rect(x, y, pdfWidth, pdfHeight, 'F');
                     }

                     if (element.borderWidth > 0) {
                        const [borderR, borderG, borderB] = hexToRgb(element.borderColor || '#000000');
                        doc.setDrawColor(borderR, borderG, borderB);
                        doc.setLineWidth(element.borderWidth);

                        if (element.borderStyle === 'dashed') {
                           doc.setLineDash([3, 3]);
                        } else if (element.borderStyle === 'dotted') {
                           doc.setLineDash([1, 1]);
                        } else {
                           doc.setLineDash([]);
                        }

                        if (element.borderRadius > 0) {
                           doc.roundedRect(x, y, pdfWidth, pdfHeight, element.borderRadius, element.borderRadius, 'S');
                        } else {
                           doc.rect(x, y, pdfWidth, pdfHeight, 'S');
                        }
                     }

                     let imageFormat = 'JPEG';
                     if (imageData.includes('data:image/png')) {
                        imageFormat = 'PNG';
                     } else if (imageData.includes('data:image/gif')) {
                        imageFormat = 'GIF';
                     } else if (imageData.includes('data:image/webp')) {
                        imageFormat = 'WEBP';
                     }

                     doc.addImage(
                        imageData,
                        imageFormat,
                        x + offsetX,
                        y + offsetY,
                        finalWidth,
                        finalHeight,
                        undefined,
                        'FAST',
                        element.rotation || 0,
                     );

                     if (element.overlay) {
                        const [overlayR, overlayG, overlayB] = hexToRgb(element.overlay.color || '#000000');
                        doc.setFillColor(overlayR, overlayG, overlayB);
                        doc.setGState(new doc.GState({ opacity: element.overlay.opacity || 0.5 }));
                        doc.rect(x, y, pdfWidth, pdfHeight, 'F');
                        doc.setGState(new doc.GState({ opacity: 1 }));
                     }
                  } catch (error) {
                     console.error('Error adding image to PDF:', error);
                     const [placeholderR, placeholderG, placeholderB] = hexToRgb('#f5f5f5');
                     doc.setFillColor(placeholderR, placeholderG, placeholderB);
                     doc.rect(x, y, element.width, element.height, 'F');
                     doc.setDrawColor(200, 200, 200);
                     doc.setLineWidth(1);
                     doc.rect(x, y, element.width, element.height, 'S');
                     doc.setDrawColor(150, 150, 150);
                     doc.setLineWidth(2);
                     doc.line(x + 10, y + 10, x + element.width - 10, y + element.height - 10);
                     doc.line(x + element.width - 10, y + 10, x + 10, y + element.height - 10);
                     doc.setFontSize(10);
                     doc.setTextColor(128, 128, 128);
                     doc.text('Image not available', x + 10, y + element.height / 2);
                  }
               } else if (element.type === 'line') {
                  const [lineR, lineG, lineB] = hexToRgb(element.color || '#000000');
                  doc.setDrawColor(lineR, lineG, lineB);
                  doc.setLineWidth(element.thickness || element.height || 1);

                  if (element.rotation) {
                     // For rotated lines, we need to calculate the end points
                     const radians = (element.rotation * Math.PI) / 180;

                     // Adjust starting point for vertical lines (90 degrees)
                     let startX = x;
                     let startY = y;

                     if (Math.abs(element.rotation) === 90) {
                        // For vertical lines, start from width/2 offset
                        startX = x + element.width / 2;
                     }

                     const endX = startX + element.width * Math.cos(radians);
                     const endY = startY + element.width * Math.sin(radians);
                     doc.line(startX, startY, endX, endY);
                  } else {
                     // Horizontal line
                     doc.line(x, y + element.height / 2, x + element.width, y + element.height / 2);
                  }
               } else if (element.type === 'barcode') {
                  try {
                     // Generate barcode using canvas instead of SVG
                     const generateBarcodeCanvas = (value, options = {}) => {
                        try {
                           const barcodeValue = value || '123456789012';
                           const canvas = document.createElement('canvas');
                           const ctx = canvas.getContext('2d');

                           // Set canvas dimensions based on element size
                           canvas.width = options.width || 200;
                           canvas.height = options.height || 60;

                           // Configure JsBarcode to render on canvas
                           JsBarcode(canvas, barcodeValue.toString(), {
                              format: options.format || 'CODE128',
                              width: options.barWidth || 1,
                              height: options.barHeight || 40,
                              displayValue: options.showText !== false,
                              fontSize: options.fontSize || 10,
                              marginTop: options.marginTop || 0,
                              textMargin: options.textMargin || 0,
                              background: options.backgroundColor || '#FFFFFF',
                              lineColor: options.foregroundColor || '#000000',
                           });

                           // Convert canvas to data URL (PNG format)
                           return canvas.toDataURL('image/png');
                        } catch (error) {
                           console.error('Error generating barcode canvas:', error);
                           return null;
                        }
                     };

                     // Calculate barcode dimensions
                     const barcodeHeight = element.barHeight || 40;
                     const textHeight = element.showText !== false ? (element.fontSize || 10) + 10 : 0;
                     const totalBarcodeHeight = barcodeHeight + textHeight;

                     // Generate barcode with proper options
                     const barcodeDataURL = generateBarcodeCanvas(
                        setupPrintSingle[0][element.id] || element.barcodeValue || element.content,
                        {
                           width: element.width,
                           height: totalBarcodeHeight,
                           format: element.barcodeFormat || 'CODE128',
                           barWidth: element.barWidth || 1,
                           barHeight: barcodeHeight,
                           foregroundColor: element.foregroundColor || '#000000',
                           backgroundColor: element.backgroundColor || '#FFFFFF',
                           showText: element.showText !== false,
                           fontSize: element.fontSize || 10,
                           marginTop: element.marginTop || 0,
                           textMargin: element.textMargin || 0,
                        },
                     );

                     if (!barcodeDataURL) {
                        throw new Error('Failed to generate barcode');
                     }

                     // Add background if specified
                     if (element.backgroundColor && element.backgroundColor !== 'transparent') {
                        const [bgR, bgG, bgB] = hexToRgb(element.backgroundColor);
                        doc.setFillColor(bgR, bgG, bgB);
                        doc.rect(x, y, element.width, element.height, 'F');
                     }

                     // Add border if specified
                     if (element.borderWidth > 0) {
                        const [borderR, borderG, borderB] = hexToRgb(element.borderColor || '#000000');
                        doc.setDrawColor(borderR, borderG, borderB);
                        doc.setLineWidth(element.borderWidth);

                        if (element.borderStyle === 'dashed') {
                           doc.setLineDash([3, 3]);
                        } else if (element.borderStyle === 'dotted') {
                           doc.setLineDash([1, 1]);
                        } else {
                           doc.setLineDash([]);
                        }

                        if (element.borderRadius > 0) {
                           doc.roundedRect(
                              x,
                              y,
                              element.width,
                              element.height,
                              element.borderRadius,
                              element.borderRadius,
                              'S',
                           );
                        } else {
                           doc.rect(x, y, element.width, element.height, 'S');
                        }
                     }

                     // Center the barcode vertically within the element
                     let barcodeY = y;
                     if (element.height > totalBarcodeHeight) {
                        barcodeY = y + (element.height - totalBarcodeHeight) / 2;
                     }

                     // Add the barcode image to PDF using PNG format
                     doc.addImage(
                        barcodeDataURL,
                        'PNG',
                        x,
                        barcodeY,
                        element.width,
                        totalBarcodeHeight,
                        undefined,
                        'FAST',
                     );
                  } catch (error) {
                     console.error('Error adding barcode to PDF:', error);

                     // Fallback: draw placeholder rectangle with text
                     const [placeholderR, placeholderG, placeholderB] = hexToRgb('#f5f5f5');
                     doc.setFillColor(placeholderR, placeholderG, placeholderB);
                     doc.rect(x, y, element.width, element.height, 'F');
                     doc.setDrawColor(200, 200, 200);
                     doc.setLineWidth(1);
                     doc.rect(x, y, element.width, element.height, 'S');

                     // Add placeholder text
                     doc.setFontSize(10);
                     doc.setTextColor(128, 128, 128);
                     const barcodeText =
                        setupPrintSingle[0]['barcodevalue'] ||
                        element.barcodeValue ||
                        element.content ||
                        'Barcode Error';
                     doc.text(barcodeText, x + element.width / 2, y + element.height / 2, { align: 'center' });
                  }
               } else {
                  // Handle text elements with enhanced wrapping
                  if (element.backgroundColor && element.backgroundColor !== 'transparent') {
                     const [textBgR, textBgG, textBgB] = hexToRgb(element.backgroundColor);
                     doc.setFillColor(textBgR, textBgG, textBgB);
                     doc.rect(x, y, element.width, element.height, 'F');
                  }

                  if (element.borderWidth > 0) {
                     const [textBorderR, textBorderG, textBorderB] = hexToRgb(element.borderColor || '#000000');
                     doc.setDrawColor(textBorderR, textBorderG, textBorderB);
                     doc.setLineWidth(element.borderWidth);

                     if (element.borderStyle === 'dashed') {
                        doc.setLineDash([3, 3]);
                     } else if (element.borderStyle === 'dotted') {
                        doc.setLineDash([1, 1]);
                     } else {
                        doc.setLineDash([]);
                     }

                     if (element.borderRadius > 0) {
                        doc.roundedRect(
                           x,
                           y,
                           element.width,
                           element.height,
                           element.borderRadius,
                           element.borderRadius,
                           'S',
                        );
                     } else {
                        doc.rect(x, y, element.width, element.height, 'S');
                     }
                  }

                  doc.setFontSize(fontSize);
                  const fontStyle = element.fontWeight === 'bold' ? 'bold' : 'normal';
                  doc.setFont(undefined, fontStyle);

                  const [textR, textG, textB] = hexToRgb(element.color || '#000000');
                  doc.setTextColor(textR, textG, textB);

                  const lineHeight = element.lineHeight || 1.2;
                  const actualLineHeight = fontSize * lineHeight;

                  // Get text wrapping behavior
                  const wrapBehavior = getTextWrapBehavior(element);
                  const contentString =
                     element.content !== null && element.content !== undefined ? String(element.content) : '';
                  let lines;
                  if (wrapBehavior.shouldWrap) {
                     // Calculate available width for text
                     const availableWidth = element.width - (element.padding || 0) * 2;
                     lines = wrapText(contentString, availableWidth, fontSize, fontStyle);
                  } else {
                     // Use original line splitting for non-wrapping elements
                     // lines = element.content.split('\n');
                     lines = contentString.split('\n');
                  }
                  // Calculate vertical alignment offset
                  const totalTextHeight = lines.length * actualLineHeight;
                  const availableHeight = element.height - (element.padding || 0) * 2;
                  let verticalOffset = 0;

                  switch (element.verticalAlign) {
                     case 'top':
                        verticalOffset = 0;
                        break;
                     case 'middle':
                        verticalOffset = Math.max(0, (availableHeight - totalTextHeight) / 2);
                        break;
                     case 'bottom':
                        verticalOffset = Math.max(0, availableHeight - totalTextHeight);
                        break;
                     case 'baseline':
                        // For baseline, align to the baseline of the first line
                        verticalOffset = 0;
                        break;
                     default:
                        // Default to top alignment
                        verticalOffset = 0;
                        break;
                  }

                  lines.forEach((line, index) => {
                     let textX = x + (element.padding || 0);
                     let textOptions = {};

                     let displayText = line;
                     if (element.textTransform === 'uppercase') {
                        displayText = line.toUpperCase();
                     } else if (element.textTransform === 'lowercase') {
                        displayText = line.toLowerCase();
                     } else if (element.textTransform === 'capitalize') {
                        displayText = line.charAt(0).toUpperCase() + line.slice(1);
                     }

                     if (element.textAlign === 'center') {
                        textX = x + element.width / 2;
                        textOptions.align = 'center';
                     } else if (element.textAlign === 'right') {
                        textX = x + element.width - (element.padding || 0);
                        textOptions.align = 'right';
                     }

                     if (element.letterSpacing && element.letterSpacing !== 0) {
                        textOptions.charSpace = element.letterSpacing;
                     }

                     // const textY = y + (element.padding || 0) + index * actualLineHeight + fontSize;
                     const textY = y + (element.padding || 0) + verticalOffset + index * actualLineHeight + fontSize;
                     doc.text(displayText, textX, textY, textOptions);
                  });
               }
            });
         };

         // Function to render table with pagination
         const renderTableWithPagination = (element) => {
            const x = element.x;
            const y = element.y;
            const fields = element.tableFields;
            const rows = setupPrintSingle || [];
            const rowHeight = 20;
            const headerHeight = 20;

            // Calculate dynamic row heights for pagination
            const calculateRowHeights = (rows) => {
               return rows.map((row) => {
                  const cellHeights = fields.map((field) => {
                     const cellValue = row[field.id] || field.placeholder;
                     const textValue = cellValue !== null && cellValue !== undefined ? String(cellValue) : '';

                     // Split text by \n to handle line breaks
                     const lines = textValue.split('\n');
                     const lineHeight = field.fontSize * 1.2;

                     // Calculate wrapped lines for each line
                     const fieldWidth = (element.width * field.width) / 100;
                     const maxWidth = fieldWidth - field.padding * 2;

                     let totalLines = 0;
                     lines.forEach((line) => {
                        // Use jsPDF's splitTextToSize to get accurate line count
                        doc.setFontSize(field.fontSize);
                        const wrappedLines = doc.splitTextToSize(line, maxWidth);
                        totalLines += wrappedLines.length;
                     });

                     return Math.max(rowHeight, totalLines * lineHeight + field.padding * 2);
                  });

                  return {
                     row,
                     height: Math.max(...cellHeights),
                  };
               });
            };

            // Calculate row heights for all rows
            const rowsWithHeights = calculateRowHeights(rows);

            // Split rows into pages based on available height
            const availableHeight = element.height - headerHeight;
            const pageGroups = [];
            let currentPageRows = [];
            let currentPageHeight = 0;

            rowsWithHeights.forEach((rowInfo) => {
               if (currentPageHeight + rowInfo.height > availableHeight && currentPageRows.length > 0) {
                  // Current row doesn't fit, start new page
                  pageGroups.push(currentPageRows);
                  currentPageRows = [rowInfo];
                  currentPageHeight = rowInfo.height;
               } else {
                  currentPageRows.push(rowInfo);
                  currentPageHeight += rowInfo.height;
               }
            });

            // Add remaining rows
            if (currentPageRows.length > 0) {
               pageGroups.push(currentPageRows);
            }

            const totalPages = pageGroups.length;

            for (let pageIndex = 0; pageIndex < totalPages; pageIndex++) {
               if (pageIndex > 0) {
                  // Add new page for additional table content
                  doc.addPage();
                  // Render static content on new page
                  renderStaticContent(pageIndex + 1);
               }

               const currentPageRowsData = pageGroups[pageIndex];
               const currentPageRows = currentPageRowsData.map((rowInfo) => rowInfo.row);

               // Set drawing properties for table borders
               doc.setDrawColor(0, 0, 0);
               doc.setLineWidth(1);

               let currentY = y;

               // Draw headers on each page
               let currentX = x;
               fields.forEach((field) => {
                  const fieldWidth = (element.width * field.width) / 100;

                  doc.setFontSize(element.headerStyle.fontSize);
                  doc.setFont(undefined, element.headerStyle.fontWeight);

                  doc.setFillColor(248, 249, 250);
                  doc.rect(currentX, currentY, fieldWidth, headerHeight, 'FD');

                  doc.setTextColor(0, 0, 0);
                  doc.text(field.label, currentX + field.padding, currentY + 15);
                  currentX += fieldWidth;
               });

               currentY += headerHeight;

               // Calculate dynamic row heights based on content
               const rowData = currentPageRows
                  .map((row, rowIndex) => {
                     return currentPageRowsData.find((rowInfo) => rowInfo.row === row);
                  })
                  .map((rowInfo, rowIndex) => {
                     const { row, height: dynamicRowHeight } = rowInfo;

                     const cellHeights = fields.map((field) => {
                        const cellValue = row[field.id] || field.placeholder;
                        const textValue = cellValue !== null && cellValue !== undefined ? String(cellValue) : '';

                        // Split text by \n to handle line breaks
                        const lines = textValue.split('\n');
                        const lineHeight = field.fontSize * 1.2; // Line height factor

                        return {
                           lines,
                           height: dynamicRowHeight,
                           lineHeight: lineHeight,
                        };
                     });

                     return {
                        row,
                        rowIndex,
                        height: dynamicRowHeight,
                        cellData: cellHeights,
                     };
                  });

               // Draw current page rows with dynamic heights
               rowData.forEach((rowInfo) => {
                  const { row, rowIndex, height: dynamicRowHeight, cellData } = rowInfo;

                  currentX = x;
                  fields.forEach((field, fieldIndex) => {
                     const fieldWidth = (element.width * field.width) / 100;

                     doc.setFontSize(field.fontSize);
                     doc.setFont(undefined, field.fontWeight);

                     // Draw cell background
                     if (element.alternateRowColors && rowIndex % 2 === 1) {
                        doc.setFillColor(245, 245, 245);
                        doc.rect(currentX, currentY, fieldWidth, dynamicRowHeight, 'FD');
                     } else {
                        doc.setFillColor(255, 255, 255);
                        doc.rect(currentX, currentY, fieldWidth, dynamicRowHeight, 'FD');
                     }

                     doc.setTextColor(0, 0, 0);

                     // Get cell data for this field
                     const cellInfo = cellData[fieldIndex];
                     const { lines, lineHeight } = cellInfo;

                     // Calculate text position
                     let textX = currentX + field.padding;
                     if (field.alignment === 'center') {
                        textX = currentX + fieldWidth / 2;
                     } else if (field.alignment === 'right') {
                        textX = currentX + fieldWidth - field.padding;
                     }

                     // Track current Y position for proper line spacing
                     let currentLineY = currentY + field.padding + field.fontSize;

                     // Draw each line of text with proper spacing
                     lines.forEach((line, lineIndex) => {
                        // Handle text wrapping if line is too long
                        const maxWidth = fieldWidth - field.padding * 2;
                        const wrappedLines = doc.splitTextToSize(line, maxWidth);

                        wrappedLines.forEach((wrappedLine, wrappedIndex) => {
                           doc.text(wrappedLine, textX, currentLineY, {
                              align:
                                 field.alignment === 'center'
                                    ? 'center'
                                    : field.alignment === 'right'
                                       ? 'right'
                                       : 'left',
                              maxWidth: maxWidth,
                           });

                           // Move to next line position
                           currentLineY += lineHeight;
                        });
                     });

                     currentX += fieldWidth;
                  });
                  currentY += dynamicRowHeight;
               });

               // Draw outer table border with actual used height
               const actualTableHeight = headerHeight + rowData.reduce((sum, rowInfo) => sum + rowInfo.height, 0);
               doc.setDrawColor(0, 0, 0);
               doc.setLineWidth(1);
               doc.rect(x, y, element.width, actualTableHeight, 'S');

               if (element.showColumnLines) {
                  let columnX = x;
                  fields.forEach((field, fieldIndex) => {
                     if (fieldIndex < fields.length - 1) {
                        // Don't draw line after last column
                        const fieldWidth = (element.width * field.width) / 100;
                        columnX += fieldWidth;

                        // Draw vertical line for the column
                        doc.setDrawColor(
                           field.borderColor ? hexToRgb(field.borderColor)[0] : 226,
                           field.borderColor ? hexToRgb(field.borderColor)[1] : 232,
                           field.borderColor ? hexToRgb(field.borderColor)[2] : 240,
                        );
                        doc.setLineWidth(field.borderWidth || 1);
                        doc.line(columnX, y, columnX, y + actualTableHeight);
                     }
                  });
               }

               // Add page number if multiple pages
               if (totalPages > 1) {
                  doc.setFontSize(10);
                  doc.setTextColor(128, 128, 128);
                  doc.text(
                     `Page ${pageIndex + 1} of ${totalPages}`,
                     x + element.width - 50,
                     y + actualTableHeight + 15,
                  );
               }
            }
         };

         // Render static content on first page
         renderStaticContent(1);

         // Process each table element
         tableElements.forEach((element) => {
            if (element.type === 'table' && element.tableFields) {
               renderTableWithPagination(element);
            }
         });

         // doc.save('invoice-format.pdf');
         toast({
            title: 'PDF Generated',
            description: 'Invoice format has been exported successfully!',
            status: 'success',
            duration: 3000,
            isClosable: true,
         });

         const pdfData = doc.output('arraybuffer');
         return new Blob([pdfData], { type: 'application/pdf' });
      } catch (error) {
         console.error('PDF generation failed:', error);
         toast({
            title: 'Export Failed',
            description: 'Failed to generate PDF. Please try again.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         throw error;
      } finally {
         setIsGenerating(false);
      }
   };

   // Helper function to load format data
   const loadFormatData = async (formatToUse, isAutoSend = false) => {
      if (!formatToUse || !formatToUse.id || !formatToUse.printId) {
         console.error('Invalid format selected - missing required properties:', formatToUse);
         throw new Error('The selected format is missing required properties. Please choose another format.');
      }

      let printFormatData = null;

      // Check if we already have PrintFormat data
      if (formatToUse.PrintFormat) {
         printFormatData = formatToUse.PrintFormat;
      }
      // If we only have printId, we need to fetch the actual PrintFormat data
      else if (formatToUse.printId) {
         const printFormatResult = await dispatch(setupFormatCustomQuery(formatToUse.printId));

         if (printFormatResult && printFormatResult.data) {
            printFormatData = printFormatResult.data;
         } else {
            throw new Error('Failed to fetch PrintFormat data');
         }
      } else {
         throw new Error('No PrintFormat data or printId available in format');
      }

      // Execute the query to get data
      if (!printFormatData || !printFormatData.query) {
         throw new Error('PrintFormat data is missing query property');
      }

      // Safely get the entity ID - check if SalesId exists first, then fall back to singleEntity.id
      let entityId;
      if (SalesId !== null && SalesId !== undefined) {
         entityId = SalesId.toString();
      } else if (singleEntity && singleEntity.id !== null && singleEntity.id !== undefined) {
         entityId = singleEntity.id.toString();
      } else {
         console.error('No entity ID available for query');
         throw new Error('No entity ID available for generating the document');
      }

      const result = await dispatch(
         setupFormatCustomQuery({
            query: printFormatData.query,
            entityId: entityId,
         }),
      );

      if (!result || !result.data || result.data.length === 0) {
         console.error('No data returned from setupFormatCustomQuery:', result);
         throw new Error('No data returned from format query');
      }

      // Parse HTML elements
      const html = printFormatData?.html || [];

      let parsedElements;
      if (typeof html === 'string') {
         try {
            parsedElements = JSON.parse(html);
         } catch (parseError) {
            console.error('Error parsing HTML string:', parseError);
            throw new Error('Invalid HTML format in PrintFormat data');
         }
      } else if (Array.isArray(html)) {
         parsedElements = html;
      } else if (html.elements && Array.isArray(html.elements)) {
         parsedElements = html;
      } else {
         console.error('Unexpected HTML format:', typeof html, html);
         throw new Error('Unexpected HTML format in PrintFormat data');
      }

      return parsedElements;
   };

   // const shareToWhatsApp = async (formatToUse = null, isAutoSend = false) => {
   //    let formatToProcess = formatToUse || selectedFormat;
   //    console.log('formatToProcess', selectedFormat);

   //    // First, ensure we have the setup format data
   //    try {
   //       const setupFormatResult = await dispatch(
   //          getSetupFormat({
   //             companyId: user?.loginhistory?.companyId,
   //             daybookId: singleEntity?.daybookId || daybookId,
   //          }),
   //       );

   //       console.log('Setup format result:', setupFormatResult);
   //    } catch (error) {
   //       console.error('Failed to get setup format:', error);
   //       toast({
   //          title: 'Failed to Load Formats',
   //          description: 'Could not load invoice formats. Please try again.',
   //          status: 'error',
   //          duration: 3000,
   //          isClosable: true,
   //       });
   //       return;
   //    }

   //    // If no format is selected, find and use the default format
   //    if (!formatToProcess) {
   //       if (Array.isArray(setupFormat) && setupFormat.length > 0) {
   //          // First priority: Find format with isDefault === true
   //          const defaultFormat = setupFormat.find((format) => format.isDefault === true);

   //          if (defaultFormat) {
   //             formatToProcess = defaultFormat;
   //          } else {
   //             // Second priority: If no explicit default, use first format with valid structure
   //             const firstValidFormat = setupFormat.find((format) => format.id && format.printId);

   //             if (firstValidFormat) {
   //                console.log('No default format found, using first valid format:', firstValidFormat);
   //                formatToProcess = firstValidFormat;
   //             } else {
   //                console.log('No valid formats found, using first available format:', setupFormat[0]);
   //                formatToProcess = setupFormat[0];
   //             }
   //          }
   //       } else {
   //          console.error('No formats available in setupFormat:', setupFormat);
   //          toast({
   //             title: 'No Formats Available',
   //             description: 'Please set up invoice formats first.',
   //             status: 'warning',
   //             duration: 3000,
   //             isClosable: true,
   //          });
   //          return;
   //       }
   //    }

   //    setIsProcessing(true);
   //    try {
   //       // Load format data and set preview elements
   //       const wpElements = await loadFormatData(formatToProcess, isAutoSend);
   //       setPreviewElements(wpElements);

   //       // Wait for state to update with the preview elements
   //       await new Promise((resolve) => setTimeout(resolve, 500));

   //       // Check if we have content to generate PDF
   //       let hasElements = false;
   //       if (wpElements) {
   //          if (Array.isArray(wpElements) && wpElements.length > 0) {
   //             hasElements = true;
   //          } else if (wpElements.elements && Array.isArray(wpElements.elements) && wpElements.elements.length > 0) {
   //             hasElements = true;
   //          }
   //       }

   //       if (!hasElements) {
   //          throw new Error('Failed to load document content. Please try again.');
   //       }

   //       // Generate the PDF as a blob
   //       const pdfBlob = await generatePDFBlob(wpElements);

   //       if (!(pdfBlob instanceof Blob)) {
   //          console.error('PDF blob is not a Blob instance:', pdfBlob);
   //          throw new Error('PDF generation did not return a valid Blob object');
   //       }

   //       const formData = new FormData();
   //       formData.append('file', pdfBlob, 'invoice-format.pdf');

   //       // Upload file and get the URL
   //       const uploadResult = await dispatch(getWpSetting(formData));

   //       if (uploadResult?.code !== 1) {
   //          throw new Error(uploadResult?.message || 'Failed to upload PDF file');
   //       }

   //       // Extract file URL from upload response
   //       const fileUrl = uploadResult.data?.url;

   //       if (!fileUrl) {
   //          throw new Error('File URL not received from upload');
   //       }

   //       const storedMobileNo = localStorage.getItem('mobileNo');
   //       console.log('storedMobileNo', storedMobileNo);

   //       const whatsappPayload = {
   //          companyId: Number(companyId),
   //          phone: account?.mobile || DaybookMobile || storedMobileNo,
   //          msg: 'sample message',
   //          file: fileUrl,
   //       };
   //       localStorage.removeItem('mobileNo');

   //       // Send WhatsApp message
   //       const whatsappResult = await dispatch(sendWhatsAppMessage(whatsappPayload));
   //       console.log('WhatsApp send result1111111:', whatsappResult);

   //       if (whatsappResult.code === 1) {
   //          toast({
   //             title: 'Sent to WhatsApp',
   //             description: 'Invoice has been sent via WhatsApp!',
   //             status: 'success',
   //             duration: 3000,
   //             isClosable: true,
   //          });
   //          setShouldOpenModalForWpSettings(false);
   //          setShouldOpenModalForCashBank(false);
   //          // navigate('/admin/sales/invoice');

   //          // If this was an auto-send, update the daybook to mark it as sent
   //          if (isAutoSend) {
   //             // You might want to dispatch an action to update the daybook's wpSettings
   //             // to indicate the message was sent successfully
   //             console.log('Auto-send completed successfully');
   //          }
   //       } else {
   //          if (whatsappResult?.message) {
   //             throw new Error(whatsappResult.message);
   //          }
   //          // navigate('/admin/sales/invoice');
   //       }
   //    } catch (error) {
   //       console.error('WhatsApp share failed:', error);
   //       toast({
   //          title: 'WhatsApp Share Failed',
   //          description: error.message || 'Failed to send via WhatsApp. Please try again.',
   //          status: 'error',
   //          duration: 3000,
   //          isClosable: true,
   //       });
   //    } finally {
   //       setIsProcessing(false);
   //    }
   // };
   const shareToWhatsApp = async (formatToUse = null, isAutoSend = false, type) => {
      let formatToProcess = formatToUse || selectedFormat;

      if (type === 'wp') {
         setIsProcessingWp(true);
      } else if (type === 'email') {
         setIsProcessingEmail(true);
      }
      try {
         const whatsappPayload = {
            id: formatToProcess.printId,
            entityId: singleEntity?.id || cashbankid,
            companyId: user?.loginhistory?.companyId,
            ...(type === 'wp' && { resendWp: true }),
            ...(type === 'email' && { resendEmail: true }),
         };

         const whatsappResult = await dispatch(sendWhatsAppPdf(whatsappPayload));

         if (whatsappResult.code === 1) {
            toast({
               title: 'Sent to WhatsApp',
               description: 'Invoice has been sent via WhatsApp!',
               status: 'success',
               duration: 3000,
               isClosable: true,
            });
            setShouldOpenModalForWpSettings(false);
            setShouldOpenModalForCashBank(false);

            if (isAutoSend) {
               console.log('Auto-send completed successfully');
            }
         } else {
            if (whatsappResult?.message) {
               throw new Error(whatsappResult.message);
            }
         }
      } catch (error) {
         console.error('WhatsApp share failed:', error);

         // Remove this line - it's causing the error:
         // toast.error(error?.response?.data?.message || 'Failed to share to WhatsApp');

         // Keep only the Chakra UI toast:
         toast({
            title: 'WhatsApp Share Failed',
            description:
               error?.response?.data?.message || error?.message || 'Failed to send via WhatsApp. Please try again.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      } finally {
         if (type === 'wp') {
            setIsProcessingWp(false);
         } else if (type === 'email') {
            setIsProcessingEmail(false);
         }
      }
   };

   useEffect(() => {
      if (DaybookData && DaybookData.id) {
         setIsDaybookDataLoaded(true);
      } else {
         setIsDaybookDataLoaded(false);
      }
   }, [DaybookData]);

   useEffect(() => {
      if (!DaybookData || !Array.isArray(DaybookData) || !daybookId || autoSendAttempted.current) {
         // console.log('Waiting for data to load or auto-send already attempted...');
         return;
      }

      // Find the specific daybook with matching ID
      const matchedDaybook = DaybookData.find((daybook) => Number(daybook.id) === Number(daybookId));

      if (!matchedDaybook) {
         console.log('No daybook found with id:', daybookId);
         return;
      }

      console.log('Checking WhatsApp auto-send conditions:', {
         daybookId,
         matchedDaybookId: matchedDaybook.id,
         sendWhatsApp: matchedDaybook.sendWhatsApp,
         wpSettings: matchedDaybook.wpSettings,
      });

      // Check if sendWhatsApp is true and wpSettings value is 0 (default)
      if (matchedDaybook.sendWhatsApp && matchedDaybook.wpSettings === 0) {
         autoSendAttempted.current = true; // Mark as attempted to prevent infinite loops

         // First ensure we have setup format data loaded
         dispatch(
            getSetupFormat({
               companyId: user?.loginhistory?.companyId,
               daybookId: daybookId,
            }),
         )
            .then((setupFormatResult) => {
               // Find the default format for auto-sending
               let autoSendFormat = null;

               if (Array.isArray(setupFormat) && setupFormat.length > 0) {
                  // First priority: Find format with isDefault === true
                  autoSendFormat = setupFormat.find((format) => format.isDefault === true);

                  if (!autoSendFormat) {
                     // Second priority: If no explicit default, use first format with valid structure
                     autoSendFormat = setupFormat.find((format) => format.id && format.printId);

                     if (!autoSendFormat) {
                        autoSendFormat = setupFormat[0];
                     }
                  }
               }

               if (autoSendFormat) {
                  shareToWhatsApp(autoSendFormat, true); // Pass true for isAutoSend
               } else {
                  console.error('No format available for auto-send');
               }
            })
            .catch((error) => {
               console.error('Failed to load setup format:', error);
            });
      } else {
         console.log('WhatsApp sending is disabled or wpSettings is not set to default', {
            sendWhatsApp: matchedDaybook.sendWhatsApp,
            wpSettings: matchedDaybook.wpSettings,
         });
      }
   }, [daybookId, DaybookData, account?.mobile, setupFormat]);

   // Enhanced helper function to convert hex color to RGB
   const hexToRgb = (hex) => {
      if (!hex) return [0, 0, 0];

      const namedColors = {
         transparent: [255, 255, 255],
         black: [0, 0, 0],
         white: [255, 255, 255],
         red: [255, 0, 0],
         green: [0, 255, 0],
         blue: [0, 0, 255],
      };

      if (namedColors[hex.toLowerCase()]) {
         return namedColors[hex.toLowerCase()];
      }

      hex = hex.replace('#', '');

      if (hex.length === 3) {
         hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }

      if (hex.length !== 6) {
         return [0, 0, 0];
      }

      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);

      return [isNaN(r) ? 0 : r, isNaN(g) ? 0 : g, isNaN(b) ? 0 : b];
   };
   //with word wrap

   // const PreviewModal = () => (
   //    <Modal isOpen={isPreviewOpen} onClose={onClosePreview} size="12xl">
   //       <ModalOverlay />
   //       <ModalContent maxW="100vw" maxH="100vh">
   //          <ModalHeader>
   //             <Flex>
   //                <Box>Invoice Preview </Box>
   //                <Spacer />
   //                <Button colorScheme="blue" mr={10} onClick={generatePDF} isLoading={isGenerating}>
   //                   PDF Export
   //                </Button>
   //             </Flex>
   //          </ModalHeader>
   //          <ModalCloseButton />
   //          <ModalBody>
   //             <Box
   //                // width="595px"
   //                // height="842px"
   //                width={`${getPageWidth(previewElements)}px`}
   //                height={`${getPageHeight(previewElements)}px`}
   //                bg="white"
   //                border="1px solid"
   //                borderColor="gray.300"
   //                mx="auto"
   //                position="relative"
   //                overflow="hidden">
   //                {previewElements &&
   //                   previewElements?.elements &&
   //                   previewElements?.elements?.map((element) => renderElement(element, true, setupFormat))}
   //             </Box>
   //          </ModalBody>
   //          <ModalFooter>
   //             <Button colorScheme="blue" mr={3} onClick={generatePDF} isLoading={isGenerating}>
   //                Export PDF
   //             </Button>
   //             <Button onClick={() => onClosePreview()}>Close</Button>
   //          </ModalFooter>
   //       </ModalContent>
   //    </Modal>
   // );

   const handlePrintClick = (singleEntity = {}, htmlData) => {
      const parsedElements = JSON.parse(htmlData);

      setPreviewElements(parsedElements);
      onOpenPreview();
   };

   const handleSelectAll = () => {
      if (selectedBarcodeItems.length === getTotalBarcodeItems()) {
         setSelectedBarcodeItems([]);
      } else {
         const allItems = lineItems
            .filter(
               (item) =>
                  item?.purchaseLineDetail &&
                  Array.isArray(item.purchaseLineDetail) &&
                  item.purchaseLineDetail.length > 0,
            )
            .flatMap((item) =>
               item.purchaseLineDetail
                  .filter((detail) => detail?.serialNo)
                  .map((detail) => ({
                     id: detail.serialNo,
                     serialNo: detail.serialNo,
                     barcode: detail.barcode,
                     lineItemId: item.id || Math.random().toString(),
                     itemName: item.itemName,
                  })),
            );

         setSelectedBarcodeItems(allItems);
      }
   };

   useEffect(() => {
      if (isOpen && viewDetail?.accountId && viewDetail?.accountId > 0) {
         const data = {
            id: viewDetail?.accountId,
            compId: String(user?.loginhistory?.companyId),
         };
         dispatch(getAccountById(data));
      }
   }, [dispatch, isOpen, user?.loginhistory?.companyId, viewDetail?.accountId]);

   useEffect(() => {
      if (
         singleEntity &&
         entityType &&
         isOpen &&
         entityType !== 'issueinventory' &&
         entityType !== 'receiveinventory' &&
         entityType !== 'salechallan' &&
         entityType !== 'purchasechallan'
      ) {
         const typeMap = {
            saleinvoice: 'SALES',
            salereturn: 'SALES RETURN',
            purchaseinvoice: 'PURCHASE',
            purchasereturn: 'PURCHASE RETURN',
         };
         dispatch(
            getAdjustedDocs({
               companyId: user?.loginhistory?.companyId,
               spId: singleEntity.id,
               daybookId: singleEntity.daybookId,
               accountId: singleEntity.accountId,
               type: typeMap[entityType] || undefined,
            }),
         );
      }
   }, [isOpen, user?.loginhistory?.companyId, singleEntity, entityType]);

   const getSetupFormats = useCallback(async () => {
      const companyId = user?.loginhistory?.companyId;
      const entityDaybookId = singleEntity?.daybookId || daybookId;

      console.log('getSetupFormats called with:', {
         isViewSetupFormatModalOpen,
         companyId,
         entityDaybookId,
         singleEntityDaybookId: singleEntity?.daybookId,
         daybookId,
      });

      if (!isViewSetupFormatModalOpen || !companyId || !entityDaybookId) {
         console.log('Conditions not met for API call');
         return;
      }

      try {
         console.log('✅ Making API call...');
         await dispatch(
            getSetupFormat({
               companyId,
               daybookId: entityDaybookId,
            }),
         );
         console.log('✅ API call successful');
      } catch (error) {
         console.error('❌ API call failed:', error);
      }
   }, [dispatch, isViewSetupFormatModalOpen, user?.loginhistory?.companyId, singleEntity?.daybookId, daybookId]);

   const getEditUrl = (entityType, id) => {
      switch (entityType) {
         case 'salechallan':
            return `/admin/sales/challan/edit/${id}`;
         case 'saleinvoice':
            return `/admin/sales/invoice/edit/${id}`;
         case 'salereturn':
            return `/admin/sales/return/edit/${id}`;
         case 'purchasechallan':
            return `/admin/purchase/challan/edit/${id}`;
         case 'purchaseinvoice':
            return `/admin/purchase/invoice/edit/${id}`;
         case 'purchasereturn':
            return `/admin/purchase/return/edit/${id}`;
         case 'issueinventory':
            return `/admin/inventory/issue/edit/${id}`;
         case 'receiveinventory':
            return `/admin/inventory/receive/edit/${id}`;
         default:
            throw new Error(`Invalid entity type: ${entityType}`);
      }
   };
   const handleEditClick = () => {
      setIsEditFormOpen(false);
      setIsOpenSingleView(false);

      localStorage.setItem('reopenSingleView', false);

      const editUrl = getEditUrl(entityType, singleEntity?.id);
      navigate(editUrl);
      // handleSerchClose();
   };

   const handleLogShow = () => {
      setLogId(viewDetail.id);
      onShowLog();
   };

   useEffect(() => {
      const shouldReopen = localStorage.getItem('reopenSingleView');

      if (shouldReopen) {
         // setIsOpenSingleView(true);
         localStorage.removeItem('reopenSingleView');
      }
   }, []);

   const {
      isOpen: isopenrecenttransactions,
      onOpen: onOpenrecenttransactions,
      onClose: onCloserecenttransactions,
   } = useDisclosure();

   const handlerecenttransactions = () => {
      if (entityType === 'saleinvoice' && account?.id) {
         dispatch(getSaleInvoicestransactions({ companyId: user?.loginhistory?.companyId, accountId: account.id })); // Sale Invoices
      } else if (entityType === 'salereturn' && account?.id) {
         dispatch(
            getSaleReturnInvoicestransactions({ companyId: user?.loginhistory?.companyId, accountId: account.id }),
         ); // Sale Return
      } else if (entityType === 'purchaseinvoice' && account?.id) {
         dispatch(getPurchaseInvoicestransactions({ companyId: user?.loginhistory?.companyId, accountId: account.id })); // Purchase Invoices
      } else if (entityType === 'purchasereturn' && account?.id) {
         dispatch(
            getPurchaseReturnInvoicestransactions({ companyId: user?.loginhistory?.companyId, accountId: account.id }),
         ); // Purchase Return
      } else {
         // console.log('run else code');
      }
   };

   // Sale Invoices
   useEffect(() => {
      if (saleInvoicesTransactions && saleInvoicesTransactions.length > 0) {
         setTableData(saleInvoicesTransactions);
         onOpenrecenttransactions();
      }
   }, [saleInvoicesTransactions]);

   // Sale Return
   useEffect(() => {
      if (SaleReturnInvoicestransactions && SaleReturnInvoicestransactions.length > 0) {
         setTableData(SaleReturnInvoicestransactions);
         onOpenrecenttransactions();
      }
   }, [SaleReturnInvoicestransactions]);

   // Purchase Invoices
   useEffect(() => {
      if (PurchaseInvoicestransactions && PurchaseInvoicestransactions.length > 0) {
         setTableData(PurchaseInvoicestransactions);
         onOpenrecenttransactions();
      }
   }, [PurchaseInvoicestransactions]);

   // Purchase Return
   useEffect(() => {
      if (PurchaseReturnInvoicestransactions && PurchaseReturnInvoicestransactions.length > 0) {
         setTableData(PurchaseReturnInvoicestransactions);
         onOpenrecenttransactions();
      }
   }, [PurchaseReturnInvoicestransactions]);

   useEffect(() => {
      onCloserecenttransactions();
   }, [isOpen]);

   const handlePrintWithSelectedFormat = async (formatToPrint) => {
      if (formatToPrint) {
         let entityId;
         if (SalesId !== null && SalesId !== undefined) {
            entityId = SalesId.toString();
         } else if (singleEntity && singleEntity.id !== null && singleEntity.id !== undefined) {
            entityId = singleEntity.id.toString();
         } else {
            console.error('No entity ID available for query');
            throw new Error('No entity ID available for generating the document');
         }
         const result = await dispatch(
            setupFormatCustomQuery({
               query: formatToPrint?.PrintFormat?.query,
               entityId: entityId,
            }),
         );
         if (result && result?.data && result?.data?.length > 0) {
            // const html = injectDataIntoHtml(
            //    formatToPrint?.PrintFormat?.html,
            //    result?.data?.length > 0 ? result?.data : [],
            // );
            const html = formatToPrint?.PrintFormat?.html || [];
            // console.log('html=====', html);
            setPreviewElements(html);
            // setIsPreviewOpen(true);
            onOpenPreview();
            handlePrintClick({}, html, formatToPrint?.PrintFormat?.css, navigate, '/admin/sales/invoice');
         }
      }
   };

   const handleDirectPDFExport = async (formatToPrint, action = 'export') => {
      if (formatToPrint) {
         let entityId;
         if (SalesId !== null && SalesId !== undefined) {
            entityId = SalesId.toString();
         } else if (singleEntity && singleEntity.id !== null && singleEntity.id !== undefined) {
            entityId = singleEntity.id.toString();
         } else {
            console.error('No entity ID available for query');
            throw new Error('No entity ID available for generating the document');
         }
         const result = await dispatch(
            setupFormatCustomQuery({
               query: formatToPrint?.PrintFormat?.query,
               entityId: entityId,
            }),
         );
         if (result && result?.data && result?.data?.length > 0) {
            const html = formatToPrint?.PrintFormat?.html || [];

            // Parse and set preview elements for PDF generation (without opening modal)
            const parsedElements = JSON.parse(html);
            console.log('row data', parsedElements, html, formatToPrint);
            setPreviewElements(parsedElements);
            await generatePDF(parsedElements, result?.data, action);
            console.log('generatePDF await done');
         }
      }
   };

   const handlesave = async () => {
      await new Promise((resolve) => setTimeout(resolve, 500));
      handleViewSingleData(singleEntity, "update");
   };

   const handleOnOpenModal = (serialNo) => {
      setSerialNo(serialNo);
   };

   const saveReason = useCallback(
      async (e) => {
         e.preventDefault();
         if (entityType === 'receiveinventory') {
            const payload = {
               rldId: lineDetailId,
               reason: reason,
               returnDate: returnDate,
            };
            await dispatch(addReceiveReason(payload));
         }
         if (entityType === 'issueinventory') {
            const payload = {
               ildId: lineDetailId,
               reason: reason,
               returnDate: returnDate,
            };
            console.log('save data', payload, returnDate);
            await dispatch(addIssueReason(payload));
         }
         setReason('');
         setReturnDate('');
         setLineDetailId(null);
         onCloseReturn();
         onClose();
      },
      [dispatch, entityType, lineDetailId, onClose, onCloseReturn, reason, returnDate],
   );

   const handleCloseModals = () => {
      setIsPrintBarcode(false);
   };

   const handleOpenBlock = (subdata) => {
      console.log('data', singleEntity, subdata);
      const today = new Date().toISOString().split("T")[0];
      setSelectedBlockData(subdata);
      setBlockDate(today);
      setIsBlockOpen(true);
   };

   const handleBlock = async () => {
      const playload = {
         accountId: singleEntity?.accountId,
         salesIds: [selectedBlockData?.id],
         blockedAt: blockDate,
         isBlocked: true,
         type: entityType === "saleinvoice" ? "SALES" : "PURCHASE_RETURN",
         reason: blockReason,
      };
      console.log("Blocked Data:", playload, selectedBlockData);
      const res = await dispatch(partyServiceBlock(playload));
      if (res && res?.code === 1) {
         setBlockDate('');
         setBlockReason('');
         setSelectedBlockData('');
         setIsBlockOpen(false);
         handleViewSingleData(singleEntity, "update");
      }
   };

   const handleUnBlock = async (data) => {
      const playload = {
         accountId: singleEntity?.accountId,
         salesIds: [data?.id],
         isBlocked: false,
         type: entityType === "purchasereturn" ? "PURCHASE_RETURN" : "SALES",
      };
      console.log("Blocked Data:", playload, selectedBlockData, entityType);
      const res = await dispatch(partyServiceBlock(playload));
      if (res && res?.code === 1) {
         setBlockDate('');
         setBlockReason('');
         setSelectedBlockData('');
         setIsBlockOpen(false);
         handleViewSingleData(singleEntity, "update");
      }
   };

   const handleOpenPrint = (subdata, type) => {
      console.log('data', singleEntity, subdata);
      const formData = {
         ItemName: subdata.itemName,
         type: type,
         id: subdata.id,
         serialNo: subdata.serialNo,
         barcode: subdata.barcode,
         specifications: subdata.specifications,
      };
      setFormData(formData);
      setIsPrintBarcode(true);
   };

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (isOpen && e.key.toLowerCase() === 'p' && (e.ctrlKey || e.metaKey)) {
            e.preventDefault();

            const performAction = async () => {
               if (isOpen) {
                  if (!isViewSetupFormatModalOpen && !shouldOpenModalForWpSettings && !shouldOpenModalForCashBank) {
                     onViewOpenSetupFormatModal();
                  } else if (isViewSetupFormatModalOpen || shouldOpenModalForWpSettings || shouldOpenModalForCashBank) {
                     if (selectedFormat) {
                        await handleDirectPDFExport(selectedFormat, 'print');
                        onViewCloseSetupFormatModal();
                        setViewSetupFormat({});
                        handleClick();
                     }
                  }
               }
            };

            performAction();
         }
      };

      window.addEventListener('keydown', handleKeyDown);
      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [isOpen, isViewSetupFormatModalOpen, shouldOpenModalForWpSettings, shouldOpenModalForCashBank, selectedFormat]);

   // Add ESC key handler at the top of your component
   useEffect(() => {
      const handleEsc = (event) => {
         if (event.key === 'Escape') {
            if (isOpenReturn) onCloseReturn();
            else if (isPreviewOpen) onClosePreview();
            else if (isViewSetupFormatModalOpen || shouldOpenModalForWpSettings || shouldOpenModalForCashBank) {
               onViewCloseSetupFormatModal();
               setViewSetupFormat({});
               handleClick();
            } else if (isopenrecenttransactions) onCloserecenttransactions();
            else if (isModalOpen) setIsModalOpen(false);
            else if (isOpen) handleClose();
         }
      };
      window.addEventListener('keydown', handleEsc);
      return () => window.removeEventListener('keydown', handleEsc);
   }, [isOpen, isOpenReturn, isPreviewOpen, isViewSetupFormatModalOpen, isopenrecenttransactions, isModalOpen]);

   const handleDownloadClick = () => {
      setIsNotesModalOpen(true);
   };

   const handleDownloadWithNotes = () => {
      setIsDownloading(true);

      if (singleEntity?.id && (entityType === 'purchaseinvoice' || entityType === 'receiveinventory')) {
         // Determine the type based on entityType
         const type = entityType === 'purchaseinvoice' ? 'PURCHASE' : 'RECEIVE';

         // Create payload with notes only if user entered something
         const payload = {
            id: singleEntity.id,
            type: type,
         };

         // Add notes to payload only if not empty
         if (notes.trim() !== '') {
            payload.notes = notes.trim();
         }

         dispatch(getPurchaseDocPdf(payload))
            .then((response) => {
               console.log('Download response:', response);

               if (response?.pdfBuffer) {
                  try {
                     // Create blob directly from ArrayBuffer
                     const blob = new Blob([response.pdfBuffer], {
                        type: 'application/pdf',
                     });

                     console.log('Blob created:', blob);
                     console.log('Blob size:', blob.size);
                     console.log('Blob type:', blob.type);

                     // Check if blob is valid
                     if (blob.size === 0) {
                        throw new Error('Generated PDF blob is empty');
                     }

                     // Create download link
                     const blobUrl = URL.createObjectURL(blob);
                     const link = document.createElement('a');
                     link.href = blobUrl;

                     // Set appropriate filename based on entity type
                     const filename =
                        entityType === 'purchaseinvoice'
                           ? `purchase-invoice-${singleEntity.docno || singleEntity.id}.pdf`
                           : `receive-inventory-${singleEntity.docno || singleEntity.id}.pdf`;

                     link.download = filename;
                     link.style.display = 'none';

                     // Append to body and trigger download
                     document.body.appendChild(link);
                     link.click();
                     document.body.removeChild(link);

                     // Clean up
                     setTimeout(() => {
                        URL.revokeObjectURL(blobUrl);
                     }, 100);

                     toast({
                        title: 'Download Complete',
                        description: `${entityType === 'purchaseinvoice' ? 'Purchase invoice' : 'Receive inventory'
                           } downloaded successfully!`,
                        status: 'success',
                        duration: 3000,
                        isClosable: true,
                     });

                     // Close modal and reset notes after successful download
                     setIsNotesModalOpen(false);
                     setNotes('');
                  } catch (conversionError) {
                     console.error('Blob creation error:', conversionError);
                     throw new Error('Failed to create PDF file: ' + conversionError.message);
                  }
               } else {
                  throw new Error('No PDF data received from server');
               }
            })
            .catch((error) => {
               console.error('Download process failed:', error);
               toast({
                  title: 'Download Failed',
                  description:
                     error.message ||
                     `Failed to download ${entityType === 'purchaseinvoice' ? 'purchase invoice' : 'receive inventory'
                     }`,
                  status: 'error',
                  duration: 5000,
                  isClosable: true,
               });
            })
            .finally(() => {
               setIsDownloading(false);
            });
      }
   };

   const handleCloseModal = () => {
      setIsNotesModalOpen(false);
      setNotes('');
      setIsDownloading(false);
   };

   const formatToDDMMYYYY = (inputDate) => {
      if (!inputDate) return '';

      let dateObj;

      if (typeof inputDate === 'string' && inputDate.includes('/')) {
         const [dd, mm, yyyy] = inputDate.split('/');
         dateObj = new Date(`${yyyy}-${mm}-${dd}`);
      } else {
         dateObj = new Date(inputDate);
      }

      if (isNaN(dateObj)) return '';

      const dd = String(dateObj.getDate()).padStart(2, '0');
      const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
      const yyyy = dateObj.getFullYear();

      return `${dd}/${mm}/${yyyy}`;
   };

   return (
      <>
         <Modal isOpen={isOpen} onClose={handleClose} size="6xl">
            <ModalOverlay backdropFilter="blur(4px)" bg={isDark ? 'blackAlpha.700' : 'blackAlpha.600'} />
            <ModalContent
               bg={isDark ? 'gray.800' : 'white'}
               boxShadow="2xl"
               borderRadius="2xl"
               className="transition-all duration-300">
               {/* Navigation Buttons */}
               {/* <Flex
                  position="absolute"
                  left="-10%"
                  top="50%"
                  transform="translateX(-50%)"
                  gap={4}
                  className="transition-all duration-200">
                  <Button
                     variant="ghost"
                     bg={isDark ? 'gray.700' : 'gray.100'}
                     _hover={{ bg: isDark ? 'gray.600' : 'gray.200', transform: 'scale(1.1)' }}
                     w={12}
                     h={12}
                     borderRadius="50%"
                     disabled={paginate?.hasPreviousPage === false}
                     onClick={() => handlePrevPage(paginate?.previousPage)}
                     boxShadow="lg"
                     className="transition-all duration-200">
                     <GrFormPrevious size={22} color={isDark ? 'white' : 'black'} />
                  </Button>
               </Flex>
               <Flex
                  position="absolute"
                  right="-10%"
                  top="50%"
                  transform="translateX(50%)"
                  gap={4}
                  className="transition-all duration-200">
                  <Button
                     variant="ghost"
                     bg={isDark ? 'gray.700' : 'gray.100'}
                     _hover={{ bg: isDark ? 'gray.600' : 'gray.200', transform: 'scale(1.1)' }}
                     w={12}
                     h={12}
                     isDisabled={paginate?.hasNextPage === false}
                     borderRadius="50%"
                     onClick={() => handleNextPage(paginate?.nextPage)}
                     boxShadow="lg"
                     className="transition-all duration-200">
                     <GrFormNext size={22} color={isDark ? 'white' : 'black'} />
                  </Button>
               </Flex> */}

               {/* Header */}
               <ModalHeader
                  bg={isDark ? 'gray.900' : 'gray.50'}
                  borderTopRadius="2xl"
                  borderBottom="2px"
                  borderColor={isDark ? 'gray.700' : 'gray.200'}>
                  <Flex alignItems={'center'}>
                     <HStack>
                        <Box>
                           <Text
                              fontSize="28px"
                              fontWeight="bold"
                              display="flex"
                              alignItems="center"
                              color={isDark ? 'white' : 'gray.800'}
                              className="transition-colors duration-200">
                              {title}#{viewDetail?.docno}
                              <Text fontSize="20px" fontWeight="normal" ml={2} color={isDark ? 'gray.400' : 'gray.600'}>
                                 {entityType === 'purchaseinvoice' || entityType === 'purchasereturn'
                                    ? '(PartyNo :- ' + viewDetail?.partyNo + ')'
                                    : null}
                              </Text>
                           </Text>
                        </Box>

                        {/* Action Icons */}
                        <Flex position="absolute" right="12" top="4" gap={1}>
                           {(entityType === 'purchaseinvoice' || entityType === 'receiveinventory') && (
                              <>
                                 <Box
                                    cursor="pointer"
                                    onClick={handleDownloadClick}
                                    _hover={{
                                       bg: isDark ? 'gray.700' : 'gray.200',
                                       transform: 'scale(1.1)',
                                       borderRadius: '50px',
                                    }}
                                    p="10px"
                                    title={`Download ${entityType === 'purchaseinvoice' ? 'Purchase Invoice' : 'Receive Inventory'
                                       } Document`}
                                    className="transition-all duration-200">
                                    <FaRegFilePdf size={23} />
                                 </Box>

                                 {/* Notes Modal */}
                                 <Modal isOpen={isNotesModalOpen} onClose={handleCloseModal} size="md">
                                    <ModalOverlay />
                                    <ModalContent>
                                       <ModalHeader>
                                          Download{' '}
                                          {entityType === 'purchaseinvoice' ? 'Purchase Invoice' : 'Receive Inventory'}
                                       </ModalHeader>
                                       <ModalCloseButton />
                                       <ModalBody>
                                          <VStack spacing={4} align="stretch">
                                             <Text fontSize="sm" color="gray.600">
                                                Add optional notes to include with your{' '}
                                                {entityType === 'purchaseinvoice'
                                                   ? 'purchase invoice'
                                                   : 'receive inventory'}
                                                :
                                             </Text>
                                             <Textarea
                                                value={notes}
                                                onChange={(e) => setNotes(e.target.value)}
                                                placeholder="Enter notes here (optional)..."
                                                size="md"
                                                resize="vertical"
                                                minHeight="120px"
                                             />
                                          </VStack>
                                       </ModalBody>
                                       <ModalFooter>
                                          <Button
                                             variant="outline"
                                             mr={3}
                                             onClick={handleCloseModal}
                                             isDisabled={isDownloading}>
                                             Cancel
                                          </Button>
                                          <Button
                                             colorScheme="blue"
                                             onClick={handleDownloadWithNotes}
                                             isLoading={isDownloading}
                                             loadingText="Downloading...">
                                             Download
                                          </Button>
                                       </ModalFooter>
                                    </ModalContent>
                                 </Modal>
                              </>
                           )}
                           <Box
                              cursor="pointer"
                              onClick={handleLogShow}
                              _hover={{
                                 bg: isDark ? 'gray.700' : 'gray.200',
                                 transform: 'scale(1.1)',
                                 borderRadius: '50px',
                              }}
                              p="10px"
                              title="About"
                              className="transition-all duration-200">
                              <img src={about} alt="Edit" width={23} />
                           </Box>
                           {(Admin || singleEntityRights?.edit) &&
                              !user.isExpired &&
                              (entityType === 'saleinvoice'
                                 ? user?.packageData?.[0]?.sales_invoice
                                 : entityType === 'salereturn'
                                    ? user?.packageData?.[0]?.sales_return
                                    : entityType === 'purchaseinvoice'
                                       ? user?.packageData?.[0]?.purchase_invoice
                                       : entityType === 'purchasereturn'
                                          ? user?.packageData?.[0]?.purchase_return
                                          : entityType === 'issueinventory'
                                             ? user?.packageData?.[0]?.issue
                                             : entityType === 'receiveinventory'
                                                ? user?.packageData?.[0]?.receive
                                                : entityType === 'salechallan'
                                                   ? user?.packageData?.[0]?.sales_challan
                                                   : entityType === 'purchasechallan'
                                                      ? user?.packageData?.[0]?.purchase_challan
                                                      : false) && (
                                 <Box
                                    cursor="pointer"
                                    onClick={handleEditClick}
                                    _hover={{
                                       bg: isDark ? 'gray.700' : 'gray.200',
                                       transform: 'scale(1.1)',
                                       borderRadius: '50px',
                                    }}
                                    p="10px"
                                    title="Edit"
                                    className="transition-all duration-200">
                                    <img src={editIcon} alt="Edit" width={23} />
                                 </Box>
                              )}
                           {viewDetail?.pendingstatus !== 'CLEAR' &&
                              isCashBankAccesible &&
                              (Admin || hasCashRight || hasBankRight) &&
                              !user.isExpired &&
                              (user?.packageData?.[0]?.cash || user?.packageData?.[0]?.bank) && (
                                 <Menu>
                                    <MenuButton
                                       as={Box}
                                       cursor="pointer"
                                       _hover={{
                                          bg: isDark ? 'gray.700' : 'gray.200',
                                          transform: 'scale(1.1)',
                                          borderRadius: '50px',
                                       }}
                                       p="10px"
                                       title="Receipt"
                                       className="transition-all duration-200">
                                       <img src={receiptIcon} alt="receipt" width={23} />
                                    </MenuButton>
                                    <MenuList
                                       p={3}
                                       bg={isDark ? 'gray.800' : 'white'}
                                       borderColor={isDark ? 'gray.700' : 'gray.200'}>
                                       {hasBankRight && user?.packageData?.[0]?.bank && (
                                          <MenuItem
                                             fontSize="md"
                                             fontWeight="bold"
                                             onClick={handleBankPaymentClick}
                                             bg={isDark ? 'gray.800' : 'white'}
                                             _hover={{ bg: isDark ? 'gray.700' : 'gray.100' }}
                                             color={isDark ? 'white' : 'gray.800'}>
                                             Bank
                                          </MenuItem>
                                       )}
                                       {hasCashRight && user?.packageData?.[0]?.cash && (
                                          <MenuItem
                                             fontSize="md"
                                             fontWeight="bold"
                                             onClick={handleCashPaymentClick}
                                             bg={isDark ? 'gray.800' : 'white'}
                                             _hover={{ bg: isDark ? 'gray.700' : 'gray.100' }}
                                             color={isDark ? 'white' : 'gray.800'}>
                                             Cash
                                          </MenuItem>
                                       )}
                                    </MenuList>
                                 </Menu>
                              )}
                           <Box
                              cursor="pointer"
                              _hover={{
                                 bg: isDark ? 'gray.700' : 'gray.200',
                                 transform: 'scale(1.1)',
                                 borderRadius: '50px',
                              }}
                              p="10px"
                              title="Print"
                              onClick={() => {
                                 onViewOpenSetupFormatModal();
                              }}
                              // onClick={() => handlePrintClick(singleEntity)}
                              className="transition-all duration-200">
                              <img src={printIcon} alt="Print" width={23} />
                           </Box>
                           {/* <Box
                              cursor="pointer"
                              _hover={{
                                 bg: isDark ? 'gray.700' : 'gray.200',
                                 transform: 'scale(1.1)',
                                 borderRadius: '50px',
                              }}
                              py="7px"
                              px="10px"
                              title="Print"
                              onClick={() => {
                                 onViewOpenSetupFormatModal();
                              }}
                              // onClick={() => handlePrintClick(singleEntity)}
                              className="transition-all duration-200">
                              <Icon as={FiPrinter} boxSize={5} />
                           </Box> */}
                           <Box
                              cursor="pointer"
                              _hover={{
                                 bg: isDark ? 'gray.700' : 'gray.200',
                                 transform: 'scale(1.1)',
                                 borderRadius: '50px',
                              }}
                              p="10px"
                              onClick={handleBarcodePrint}
                              title="Print Barcodes"
                              position="relative"
                              className="transition-all duration-200">
                              <img src={dwonloadIcon} alt="Download" width={23} />
                              {selectedBarcodeItems.length > 0 && (
                                 <Badge
                                    colorScheme="blue"
                                    borderRadius="full"
                                    position="absolute"
                                    top="-5px"
                                    right="-5px"
                                    fontSize="xs"
                                    className="animate-pulse">
                                    {selectedBarcodeItems.length}
                                 </Badge>
                              )}
                           </Box>
                           {(Admin || singleEntityRights?.deleteRole) &&
                              !user.isExpired &&
                              (entityType === 'saleinvoice'
                                 ? user?.packageData?.[0]?.sales_invoice
                                 : entityType === 'salereturn'
                                    ? user?.packageData?.[0]?.sales_return
                                    : entityType === 'purchaseinvoice'
                                       ? user?.packageData?.[0]?.purchase_invoice
                                       : entityType === 'purchasereturn'
                                          ? user?.packageData?.[0]?.purchase_return
                                          : entityType === 'issueinventory'
                                             ? user?.packageData?.[0]?.issue
                                             : entityType === 'receiveinventory'
                                                ? user?.packageData?.[0]?.receive
                                                : entityType === 'salechallan'
                                                   ? user?.packageData?.[0]?.sales_challan
                                                   : entityType === 'purchasechallan'
                                                      ? user?.packageData?.[0]?.purchase_challan
                                                      : false) && (
                                 <Menu>
                                    <MenuButton
                                       as={Box}
                                       cursor="pointer"
                                       _hover={{
                                          bg: isDark ? 'gray.700' : 'gray.200',
                                          transform: 'scale(1.1)',
                                          borderRadius: '50px',
                                       }}
                                       p="10px"
                                       title="menu"
                                       className="transition-all duration-200">
                                       <img src={dotIcon} alt="Menu" width={23} />
                                    </MenuButton>
                                    <MenuList
                                       p={3}
                                       bg={isDark ? 'gray.800' : 'white'}
                                       borderColor={isDark ? 'gray.700' : 'gray.200'}>
                                       <MenuItem
                                          onClick={() => onDelete()}
                                          fontSize={'md'}
                                          fontWeight={'bold'}
                                          bg={isDark ? 'gray.800' : 'white'}
                                          _hover={{ bg: isDark ? 'red.900' : 'red.50' }}
                                          color={isDark ? 'red.400' : 'red.600'}>
                                          Delete
                                       </MenuItem>
                                    </MenuList>
                                 </Menu>
                              )}
                        </Flex>
                     </HStack>
                  </Flex>
               </ModalHeader>
               <ModalCloseButton
                  color={isDark ? 'white' : 'gray.800'}
                  _hover={{ bg: isDark ? 'gray.700' : 'gray.200' }}
               />

               {/* Body */}
               <ModalBody p={4} bg={isDark ? 'gray.800' : 'white'}>
                  <Flex gap={4} flexWrap="wrap">
                     <Box flex="1" minW="300px">
                        {/* Bill To Card */}
                        <Box
                           p="4"
                           borderWidth="2px"
                           borderRadius={'xl'}
                           mb={2}
                           bg={isDark ? 'gray.900' : 'gray.50'}
                           borderColor={isDark ? 'gray.700' : 'gray.200'}
                           boxShadow="lg"
                           className="transition-all duration-200 hover:shadow-xl">
                           <div className="flex items-center">
                              <Text fontSize="lg" fontWeight="bold" mb={1} color={isDark ? 'blue.400' : 'blue.600'}>
                                 Bill To : -
                              </Text>
                              <Box display="flex" alignItems="center" mb={1} ml={2}>
                                 <Text fontSize="xl" fontWeight="semibold" mr={3} color={isDark ? 'white' : 'gray.800'}>
                                    {account?.name}
                                 </Text>
                                 {account?.id && (
                                    <Box
                                       as="img"
                                       src={recenttransactions}
                                       alt="receipt"
                                       h="20px"
                                       w="20px"
                                       cursor="pointer"
                                       onClick={handlerecenttransactions}
                                       _hover={{ transform: 'scale(1.2)' }}
                                       className="transition-transform duration-200"
                                    />
                                 )}
                              </Box>
                           </div>
                           <Text mb={2} color={isDark ? 'gray.300' : 'gray.700'}>
                              <b>Mobile No. :</b> {account?.mobile || '-'}
                           </Text>
                           <Text mb={2} color={isDark ? 'gray.300' : 'gray.700'}>
                              <b>PAN No. :</b> {account?.panNo || '-'}
                           </Text>
                           <Text fontWeight="bold" mt={3} color={isDark ? 'gray.200' : 'gray.800'}>
                              Billing Address
                           </Text>
                           <Text color={isDark ? 'gray.400' : 'gray.600'}>{account?.address1 || '-'}</Text>
                           <Text mt={3} color={isDark ? 'gray.300' : 'gray.700'}>
                              <b>Notes :</b> {viewDetail?.notes || '-'}
                           </Text>
                        </Box>

                        {/* Receipt Details */}
                        {adjustedDocs &&
                           adjustedDocs.length > 0 &&
                           entityType !== 'issueinventory' &&
                           entityType !== 'receiveinventory' && (
                              <Box
                                 borderWidth="2px"
                                 borderRadius="xl"
                                 p={3}
                                 boxShadow="lg"
                                 bg={isDark ? 'gray.900' : 'white'}
                                 borderColor={isDark ? 'gray.700' : 'gray.200'}
                                 className="transition-all duration-200">
                                 <Text
                                    fontWeight="bold"
                                    mb={3}
                                    fontSize="lg"
                                    color={isDark ? 'green.400' : 'green.600'}>
                                    Receipt Details
                                 </Text>
                                 <Table variant="simple" size="sm">
                                    <Thead>
                                       <Tr bg={isDark ? 'gray.800' : 'gray.100'}>
                                          <Th color={isDark ? 'gray.300' : 'gray.700'}>Doc No</Th>
                                          <Th color={isDark ? 'gray.300' : 'gray.700'}>Date</Th>
                                          <Th color={isDark ? 'gray.300' : 'gray.700'}>Daybook</Th>
                                          <Th isNumeric color={isDark ? 'gray.300' : 'gray.700'}>
                                             Amount
                                          </Th>
                                          <Th></Th>
                                       </Tr>
                                    </Thead>
                                    <Tbody>
                                       {adjustedDocs.map((doc, index) => (
                                          <Tr
                                             key={index}
                                             _hover={{ bg: isDark ? 'gray.800' : 'gray.50' }}
                                             className="transition-colors duration-150">
                                             <Td color={isDark ? 'white' : 'gray.800'}>
                                                <Text fontWeight="medium">{doc.adj_docno}</Text>
                                             </Td>
                                             <Td color={isDark ? 'gray.300' : 'gray.700'}>
                                                {new Date(doc.adj_txnDate).toLocaleDateString('en-IN', {
                                                   day: '2-digit',
                                                   month: '2-digit',
                                                })}
                                             </Td>
                                             <Td color={isDark ? 'gray.300' : 'gray.700'}>
                                                {doc.adj_daybookname !== viewDetail?.daybookname
                                                   ? doc.adj_daybookname
                                                   : doc.daybookname}
                                             </Td>
                                             <Td isNumeric color={isDark ? 'white' : 'gray.800'}>
                                                ₹ {doc.amount}
                                             </Td>
                                             <Td p={1}>
                                                <IconButton
                                                   icon={<CloseIcon />}
                                                   colorScheme="red"
                                                   size="sm"
                                                   aria-label="Cancel"
                                                   onClick={() => removeadj(doc)}
                                                   _hover={{ transform: 'scale(1.1)' }}
                                                   className="transition-transform duration-200"
                                                />
                                             </Td>
                                          </Tr>
                                       ))}
                                    </Tbody>
                                 </Table>
                              </Box>
                           )}
                     </Box>

                     {/* Right Side Cards */}
                     <Box minW="300px">
                        {/* Pending Amount Card */}
                        {entityType !== 'issueinventory' && entityType !== 'receiveinventory' && (
                           <Box
                              p="3"
                              mb="2"
                              borderWidth="2px"
                              borderRadius={'xl'}
                              bg={isDark ? 'gray.900' : 'orange.50'}
                              borderColor={isDark ? 'orange.700' : 'orange.200'}
                              boxShadow="lg"
                              className="transition-all duration-200 hover:shadow-xl">
                              <Text
                                 fontSize="sm"
                                 fontWeight="bold"
                                 mb={3}
                                 textTransform="uppercase"
                                 color={isDark ? 'orange.400' : 'orange.700'}>
                                 Pending Amount
                              </Text>
                              <Flex alignItems={'center'} justifyContent="space-between">
                                 <Flex alignItems={'center'}>
                                    <FaRupeeSign size={16} color={isDark ? '#FFA500' : '#FF6B00'} />
                                    <Text fontSize="2xl" fontWeight="bold" ml={2} color={isDark ? 'white' : 'gray.800'}>
                                       {viewDetail?.pendingamt || '0.00'}
                                    </Text>
                                 </Flex>
                                 <Badge
                                    px="4"
                                    py="2"
                                    borderRadius="full"
                                    fontSize="sm"
                                    fontWeight="bold"
                                    colorScheme={
                                       viewDetail?.pendingstatus === 'CLEAR'
                                          ? 'green'
                                          : viewDetail?.pendingstatus === 'FULL PENDING'
                                             ? 'orange'
                                             : viewDetail?.pendingstatus === 'PART PENDING'
                                                ? 'gray'
                                                : 'blue'
                                    }
                                    className="transition-all duration-200">
                                    {viewDetail?.pendingstatus}
                                 </Badge>
                              </Flex>
                           </Box>
                        )}

                        {/* Invoice Details Card */}
                        <Box
                           p="4"
                           borderWidth="2px"
                           borderRadius={'xl'}
                           bg={isDark ? 'gray.900' : 'blue.50'}
                           borderColor={isDark ? 'blue.700' : 'blue.200'}
                           boxShadow="lg"
                           className="transition-all duration-200 hover:shadow-xl">
                           <Text fontSize="lg" fontWeight="bold" mb={1} color={isDark ? 'blue.400' : 'blue.600'}>
                              Invoice Details
                           </Text>
                           <Box
                              mb={3}
                              p={1}
                              px={3}
                              bg={isDark ? 'gray.800' : 'white'}
                              borderRadius="lg"
                              className="transition-colors duration-200">
                              <Text fontSize="sm" color={isDark ? 'gray.400' : 'gray.600'}>
                                 Invoice Number
                              </Text>
                              <Text fontSize="md" fontWeight="bold" color={isDark ? 'white' : 'gray.800'}>
                                 {viewDetail?.docno}
                              </Text>
                           </Box>
                           <Box
                              mb={3}
                              p={1}
                              px={3}
                              v
                              bg={isDark ? 'gray.800' : 'white'}
                              borderRadius="lg"
                              className="transition-colors duration-200">
                              <Text fontSize="sm" color={isDark ? 'gray.400' : 'gray.600'}>
                                 Invoice Date
                              </Text>
                              <Text fontSize="md" fontWeight="bold" color={isDark ? 'white' : 'gray.800'}>
                                 {formatToDDMMYYYY(viewDetail?.transactionAt)}
                              </Text>
                           </Box>
                           <Box
                              p={1}
                              px={3}
                              bg={isDark ? 'gray.800' : 'white'}
                              borderRadius="lg"
                              className="transition-colors duration-200">
                              <Text fontSize="sm" color={isDark ? 'gray.400' : 'gray.600'}>
                                 Invoice Book
                              </Text>
                              <Text fontSize="md" fontWeight="bold" color={isDark ? 'white' : 'gray.800'}>
                                 {viewDetail?.daybookname}
                              </Text>
                           </Box>
                        </Box>
                     </Box>
                  </Flex>

                  {/* Items Table */}
                  <TableContainer
                     width={'full'}
                     // height="300px"
                     p="4"
                     borderWidth="2px"
                     mt={6}
                     borderRadius={'xl'}
                     overflowY="auto"
                     overflowX="auto"
                     bg={isDark ? 'gray.900' : 'white'}
                     borderColor={isDark ? 'gray.700' : 'gray.200'}
                     boxShadow="lg"
                     className="transition-all duration-200"
                     css={{
                        '&::-webkit-scrollbar': {
                           width: '8px',
                           height: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                           background: isDark ? '#2D3748' : '#EDF2F7',
                           borderRadius: '10px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                           background: isDark ? '#4A5568' : '#CBD5E0',
                           borderRadius: '10px',
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                           background: isDark ? '#718096' : '#A0AEC0',
                        },
                     }}>
                     <Table>
                        <Thead position="sticky" top="0" bg={isDark ? 'gray.800' : 'gray.100'} zIndex="1">
                           <Tr>
                              <Th color={isDark ? 'gray.300' : 'gray.700'}>
                                 <Flex alignItems="center">
                                    <Checkbox
                                       isChecked={
                                          selectedBarcodeItems.length === getTotalBarcodeItems() &&
                                          getTotalBarcodeItems() > 0
                                       }
                                       onChange={handleSelectAll}
                                       size="md"
                                       mr={2}
                                       colorScheme="blue"
                                    />
                                    <Text>Select</Text>
                                 </Flex>
                              </Th>
                              <Th color={isDark ? 'gray.300' : 'gray.700'}>Sl No</Th>
                              <Th color={isDark ? 'gray.300' : 'gray.700'}>Item</Th>
                              <Th color={isDark ? 'gray.300' : 'gray.700'}>SerialNo</Th>
                              <Th color={isDark ? 'gray.300' : 'gray.700'}>Warehouse Name</Th>
                              {entityType === 'receiveinventory' && (
                                 <>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Issue Doc No</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Issue Date</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Issue Party Name</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Purchase Doc No</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Purchase Date</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Purchase Party Name</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Purchase Rate</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Sales Doc No</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Sales Date</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Sales Party Name</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Sales Rate</Th>
                                 </>
                              )}
                              <Th color={isDark ? 'gray.300' : 'gray.700'}>Qty</Th>
                              <Th color={isDark ? 'gray.300' : 'gray.700'}>Rate</Th>
                              <Th color={isDark ? 'gray.300' : 'gray.700'}>Discount</Th>
                              <Th color={isDark ? 'gray.300' : 'gray.700'}>Total</Th>
                              {(entityType === 'receiveinventory' || entityType === 'issueinventory') && (
                                 <Th color={isDark ? 'gray.300' : 'gray.700'}>Status</Th>
                              )}
                           </Tr>
                        </Thead>
                        <Tbody>
                           {lineItems?.map((item, index) => {
                              const lineDetailKey =
                                 entityType === 'saleinvoice'
                                    ? 'salesLineDetail'
                                    : entityType === 'salereturn'
                                       ? 'salesReturnLineDetail'
                                       : entityType === 'receiveinventory'
                                          ? 'receiveLineDetail'
                                          : entityType === 'issueinventory'
                                             ? 'issueLineDetail'
                                             : entityType === 'purchaseinvoice'
                                                ? 'purchaseLineDetail'
                                                : entityType === "salechallan"
                                                   ? 'lineDetails'
                                                   : entityType === "purchasechallan"
                                                      ? 'lineDetails'
                                                      : 'purchaseReturnLineDetail';

                              const lineDetails = item[lineDetailKey] || [];

                              const serialNumbers = lineDetails?.map((subdata, index) => (
                                 <span key={index}>
                                    {subdata?.serialNo}
                                    {subdata?.serialNo && !subdata?.isBlocked && (lineDetailKey === 'salesLineDetail' || lineDetailKey === 'purchaseReturnLineDetail') && (
                                       <Icon
                                          as={MdGppGood}
                                          boxSize={4}
                                          ml={3}
                                          color="green.600"
                                          onClick={() => handleOpenBlock(subdata)}
                                          cursor="pointer"
                                       />
                                    )}
                                    {subdata?.serialNo && subdata?.isBlocked && (lineDetailKey === 'salesLineDetail' || lineDetailKey === 'purchaseReturnLineDetail') && (
                                       <Icon
                                          as={MdGppBad}
                                          boxSize={4}
                                          ml={3}
                                          color="red.600"
                                          onClick={() => handleUnBlock(subdata)}
                                          cursor="pointer"
                                       />
                                    )}
                                    {subdata?.serialNo &&
                                       (lineDetailKey === 'receiveLineDetail' ||
                                          lineDetailKey === 'purchaseLineDetail') &&
                                       user?.packageData?.[0]?.print_barcode && (
                                          <Icon
                                             as={FiPrinter}
                                             boxSize={4}
                                             ml={3}
                                             color="blue.600"
                                             onClick={() => {
                                                handleOpenPrint(
                                                   subdata,
                                                   lineDetailKey === 'receiveLineDetail' ? 'RECEIVE' : 'PURCHASE',
                                                );
                                             }}
                                             cursor="pointer"
                                          />
                                       )}
                                    {lineDetailKey === 'receiveLineDetail' &&
                                       subdata?.status !== 'SOLD' &&
                                       subdata.status !== 'ISSUE_RETURN' &&
                                       subdata?.returnStatus !== 'IS RETURN' && (
                                          <Icon
                                             as={FaHistory}
                                             boxSize={4}
                                             ml={3}
                                             color="green.600"
                                             onClick={() => {
                                                setSelectedItem(item); // Store the item data
                                                setIsIssuePurchaseModalOpen(true); // Open modal
                                                handleOnOpenModal(subdata.serialNo);
                                             }}
                                             cursor="pointer"
                                          />
                                       )}
                                    {lineDetailKey === 'issueLineDetail' &&
                                       subdata?.returnStatus !== 'IS RETURN' &&
                                       (subdata?.issueStatus === 'ISSUED_TO_VENDOR' ||
                                          (subdata?.issueStatus === 'RECEIVED_FROM_VENDOR' &&
                                             subdata?.pinvLineDetailId === null)) && (
                                          <Icon
                                             as={FaHistory}
                                             boxSize={4}
                                             ml={3}
                                             color="green.600"
                                             onClick={() => {
                                                setSelectedItem(item); // Store the item data
                                                setIsIssuePurchaseModalOpen(true); // Open modal
                                                handleOnOpenModal(subdata.serialNo);
                                             }}
                                             cursor="pointer"
                                          />
                                       )}
                                    {lineDetailKey === 'purchaseLineDetail' &&
                                       (subdata?.purchaseStatus === 'PURCHASE_ONLY' ||
                                          subdata?.purchaseStatus === 'ISSUED_TO_VENDOR' ||
                                          (subdata?.purchaseStatus === 'RECEIVED_FROM_VENDOR' &&
                                             subdata?.issueLineDetailId)) && (
                                          <Icon
                                             as={FaHistory}
                                             boxSize={4}
                                             ml={3}
                                             color="green.600"
                                             onClick={() => {
                                                setSelectedItem(item); // Store the item data
                                                setIsIssuePurchaseModalOpen(true); // Open modal
                                                handleOnOpenModal(subdata.serialNo);
                                             }}
                                             cursor="pointer"
                                          />
                                       )}

                                    {subdata.returnStatus === 'IS RETURN' ? (
                                       <Icon
                                          as={DeleteIcon}
                                          boxSize={4}
                                          ml={3}
                                          color="red.600"
                                          onClick={async () => {
                                             if (entityType === 'receiveinventory') {
                                                Swal.fire({
                                                   title: 'Are you sure?',
                                                   text: "You won't be able to revert this!",
                                                   icon: 'warning',
                                                   showCancelButton: true,
                                                   confirmButtonColor: '#3085d6',
                                                   cancelButtonColor: '#d33',
                                                   confirmButtonText: 'Yes, delete it!',
                                                }).then(async (result) => {
                                                   if (result.isConfirmed) {
                                                      const payload = {
                                                         rldId: subdata?.id,
                                                         reason: subdata?.reason,
                                                         isDeleted: true,
                                                      };
                                                      await dispatch(addReceiveReason(payload));
                                                      onClose();
                                                   }
                                                });
                                             }
                                             if (entityType === 'issueinventory') {
                                                Swal.fire({
                                                   title: 'Are you sure?',
                                                   text: "You won't be able to revert this!",
                                                   icon: 'warning',
                                                   showCancelButton: true,
                                                   confirmButtonColor: '#3085d6',
                                                   cancelButtonColor: '#d33',
                                                   confirmButtonText: 'Yes, delete it!',
                                                }).then(async (result) => {
                                                   if (result.isConfirmed) {
                                                      const payload = {
                                                         ildId: subdata?.id,
                                                         reason: subdata?.reason,
                                                         isDeleted: true,
                                                      };
                                                      await dispatch(addIssueReason(payload));
                                                      onClose();
                                                   }
                                                });
                                             }
                                          }}
                                          cursor="pointer"
                                       />
                                    ) : lineDetailKey === 'receiveLineDetail' &&
                                       subdata?.returnStatus !== 'IS RETURN' &&
                                       (subdata.status === 'RECEIVED_ONLY' || subdata.status === 'ISSUE_RETURN') ? (
                                       <Icon
                                          as={FaHistory}
                                          boxSize={4}
                                          ml={3}
                                          color="orange.600"
                                          onClick={() => {
                                             onOpenReturn();
                                             setLineDetailId(subdata?.id);
                                          }}
                                          cursor="pointer"
                                       />
                                    ) : lineDetailKey === 'issueLineDetail' &&
                                       subdata?.returnStatus !== 'IS RETURN' &&
                                       subdata?.issueStatus === 'ISSUED_TO_VENDOR' ? (
                                       <Icon
                                          as={FaHistory}
                                          boxSize={4}
                                          ml={3}
                                          color="orange.600"
                                          onClick={() => {
                                             onOpenReturn();
                                             setLineDetailId(subdata?.id);
                                          }}
                                          cursor="pointer"
                                       />
                                    ) : null}
                                    {index !== lineDetails.length - 1 ? ', ' : ''}
                                    <br />
                                 </span>
                              ));

                              const warehouseData = lineDetails?.map((subdata, index) => (
                                 <span key={index}>
                                    {subdata?.warehouseName || '-'}
                                    {index !== lineDetails.length - 1 ? ', ' : ''}
                                    <br />
                                 </span>
                              ));

                              const issueDoc = lineDetails?.map((subdata, index) => (
                                 <span key={index}>
                                    {subdata?.issueDocNo || '-'}
                                    {index !== lineDetails.length - 1 ? ', ' : ''}
                                    <br />
                                 </span>
                              ));
                              const issueDate = lineDetails?.map((subdata, index) => (
                                 <span key={index}>
                                    {subdata?.issueDate
                                       ? new Date(subdata?.issueDate).toLocaleDateString('en-GB')
                                       : '-'}
                                    {index !== lineDetails.length - 1 ? ', ' : ''}
                                    <br />
                                 </span>
                              ));
                              const issuePartyName = lineDetails?.map((subdata, index) => (
                                 <span key={index}>
                                    {subdata?.issueParty || '-'}
                                    {index !== lineDetails.length - 1 ? ', ' : ''}
                                    <br />
                                 </span>
                              ));
                              const purchaseDoc = lineDetails?.map((subdata, index) => (
                                 <span key={index}>
                                    {subdata?.purchaseDocNo || '-'}
                                    {index !== lineDetails.length - 1 ? ', ' : ''}
                                    <br />
                                 </span>
                              ));
                              const purchaseDate = lineDetails?.map((subdata, index) => (
                                 <span key={index}>
                                    {subdata?.purchaseDate
                                       ? new Date(subdata?.purchaseDate).toLocaleDateString('en-GB')
                                       : '-'}
                                    {index !== lineDetails.length - 1 ? ', ' : ''}
                                    <br />
                                 </span>
                              ));
                              const purchasePartyName = lineDetails?.map((subdata, index) => (
                                 <span key={index}>
                                    {subdata?.purchaseParty || '-'}
                                    {index !== lineDetails.length - 1 ? ', ' : ''}
                                    <br />
                                 </span>
                              ));
                              const purchaseRate = lineDetails?.map((subdata, index) => (
                                 <span key={index}>
                                    {subdata?.purchaseRate ? '₹ ' + subdata?.purchaseRate : '-'}
                                    {index !== lineDetails.length - 1 ? ', ' : ''}
                                    <br />
                                 </span>
                              ));
                              const salesDoc = lineDetails?.map((subdata, index) => (
                                 <span key={index}>
                                    {subdata?.salesDocNo || '-'}
                                    {index !== lineDetails.length - 1 ? ', ' : ''}
                                    <br />
                                 </span>
                              ));
                              const salesDate = lineDetails?.map((subdata, index) => (
                                 <span key={index}>
                                    {subdata?.salesDate
                                       ? new Date(subdata?.salesDate).toLocaleDateString('en-GB')
                                       : '-'}
                                    {index !== lineDetails.length - 1 ? ', ' : ''}
                                    <br />
                                 </span>
                              ));
                              const salesPartyName = lineDetails?.map((subdata, index) => (
                                 <span key={index}>
                                    {subdata?.salesParty || '-'}
                                    {index !== lineDetails.length - 1 ? ', ' : ''}
                                    <br />
                                 </span>
                              ));
                              const salesRate = lineDetails?.map((subdata, index) => (
                                 <span key={index}>
                                    {subdata?.salesRate ? '₹ ' + subdata?.salesRate : '-'}
                                    {index !== lineDetails.length - 1 ? ', ' : ''}
                                    <br />
                                 </span>
                              ));

                              return (
                                 <Tr
                                    key={index}
                                    _hover={{ bg: isDark ? 'gray.800' : 'gray.50' }}
                                    className="transition-colors duration-150">
                                    <Td>
                                       {entityType === 'receiveinventory' || entityType === 'purchaseinvoice'
                                          ? item?.[lineDetailKey]?.map(
                                             (detail, detailIndex) =>
                                                detail?.serialNo && (
                                                   <Tooltip
                                                      key={`${index}-${detailIndex}`}
                                                      label={detail.serialNo}
                                                      placement="top"
                                                      openDelay={200}
                                                      closeDelay={100}
                                                      isOpen={hoveredIndex === `${index}-${detailIndex}`}
                                                      closeOnClick={false}
                                                      hasArrow
                                                      bg={isDark ? 'gray.700' : 'gray.800'}>
                                                      <Box
                                                         display="inline-block"
                                                         onMouseEnter={() =>
                                                            setHoveredIndex(`${index}-${detailIndex}`)
                                                         }
                                                         onMouseLeave={() => setHoveredIndex(null)}>
                                                         <Checkbox
                                                            isChecked={isItemSelected(detail.serialNo)}
                                                            paddingLeft={2}
                                                            onChange={() =>
                                                               handleCheckboxChange(
                                                                  detail.serialNo,
                                                                  detail.serialNo,
                                                                  detail.barcode,
                                                                  item.id || `${index}-${detailIndex}`,
                                                                  item.itemName,
                                                               )
                                                            }
                                                            size="sm"
                                                            mb={detailIndex < item[lineDetailKey]?.length - 1 ? 1 : 0}
                                                            colorScheme="blue"
                                                         />
                                                      </Box>
                                                   </Tooltip>
                                                ),
                                          )
                                          : null}
                                    </Td>
                                    <Td color={isDark ? 'gray.300' : 'gray.700'}>{index + 1}</Td>
                                    <Td color={isDark ? 'white' : 'gray.800'} fontWeight="medium">
                                       {item.itemName}
                                    </Td>
                                    <Td color={isDark ? 'gray.300' : 'gray.700'}>{serialNumbers || '-'}</Td>
                                    <Td color={isDark ? 'gray.300' : 'gray.700'}>{warehouseData || '-'}</Td>
                                    {entityType === 'receiveinventory' && (
                                       <>
                                          <Td color={isDark ? 'gray.300' : 'gray.700'}>{issueDoc || '-'}</Td>
                                          <Td color={isDark ? 'gray.300' : 'gray.700'}>{issueDate || '-'}</Td>
                                          <Td color={isDark ? 'gray.300' : 'gray.700'}>{issuePartyName || '-'}</Td>
                                          <Td color={isDark ? 'gray.300' : 'gray.700'}>{purchaseDoc || '-'}</Td>
                                          <Td color={isDark ? 'gray.300' : 'gray.700'}>{purchaseDate || '-'}</Td>
                                          <Td color={isDark ? 'gray.300' : 'gray.700'}>{purchasePartyName || '-'}</Td>
                                          <Td color={isDark ? 'gray.300' : 'gray.700'}>{purchaseRate || '-'}</Td>
                                          <Td color={isDark ? 'gray.300' : 'gray.700'}>{salesDoc || '-'}</Td>
                                          <Td color={isDark ? 'gray.300' : 'gray.700'}>{salesDate || '-'}</Td>
                                          <Td color={isDark ? 'gray.300' : 'gray.700'}>{salesPartyName || '-'}</Td>
                                          <Td color={isDark ? 'gray.300' : 'gray.700'}>{salesRate || '-'}</Td>
                                       </>
                                    )}
                                    <Td color={isDark ? 'white' : 'gray.800'}>{item.qty1}</Td>
                                    <Td color={isDark ? 'white' : 'gray.800'}>₹{item.itemRate}</Td>
                                    <Td color={isDark ? 'gray.300' : 'gray.700'}>{billTerms?.[0]?.percentage || 0}%</Td>
                                    <Td color={isDark ? 'white' : 'gray.800'} fontWeight="semibold">
                                       ₹{calculateTotal(item.qty1, item.itemRate, billTerms?.[0]?.percentage || 0)}.00
                                    </Td>
                                    {(entityType === 'receiveinventory' ||
                                       entityType === 'issueinventory' ||
                                       entityType === 'purchaseinvoice') && (
                                          <Td>
                                             <Badge
                                                border="1px solid"
                                                bg="transparent"
                                                borderColor={isDark ? 'blue.400' : 'blue.500'}
                                                color={isDark ? 'blue.400' : 'blue.500'}
                                                borderRadius="md"
                                                w="100%"
                                                textAlign="center"
                                                textTransform="capitalize"
                                                className="transition-all duration-200">
                                                {lineDetails.map((subdata, index) => (
                                                   <div
                                                      key={index}
                                                      style={{ marginBottom: index !== lineDetails?.length - 1 && '5px' }}>
                                                      {entityType === 'receiveinventory'
                                                         ? subdata?.status
                                                         : entityType === 'purchaseinvoice'
                                                            ? subdata?.purchaseStatus
                                                            : subdata?.issueStatus || '-'}
                                                      {index !== lineDetails?.length - 1 && ','}
                                                   </div>
                                                ))}
                                             </Badge>
                                          </Td>
                                       )}
                                 </Tr>
                              );
                           })}
                           <Tr bg={isDark ? 'gray.800' : 'gray.100'}>
                              <Td colSpan={5} />
                              <Td display={'flex'}>
                                 <Text fontSize="sm" fontWeight="bold" color={isDark ? 'white' : 'gray.800'}>
                                    Total Qty:
                                 </Text>
                                 <Text fontSize="sm" fontWeight="bold" ml={2} color={isDark ? 'blue.400' : 'blue.600'}>
                                    {lineItems?.reduce((acc, item) => acc + item.qty1, 0)}
                                 </Text>
                              </Td>
                              <Td></Td>
                           </Tr>
                        </Tbody>
                     </Table>
                  </TableContainer>

                  {/* Net Payable */}
                  <Flex
                     mt={3}
                     p={2}
                     px={3}
                     bg={isDark ? 'gray.900' : 'green.50'}
                     borderRadius="xl"
                     borderWidth="2px"
                     borderColor={isDark ? 'green.700' : 'green.200'}
                     justifyContent="space-between"
                     alignItems="center"
                     boxShadow="lg">
                     <Box />
                     <Box display={'flex'} alignItems="center" gap={3}>
                        <Text fontSize="lg" fontWeight="600" color={isDark ? 'gray.300' : 'gray.700'}>
                           Net Payable :
                        </Text>
                        <Text fontSize="2xl" fontWeight="bold" color={isDark ? 'green.400' : 'green.600'}>
                           ₹ {viewDetail?.netAmount?.toFixed(2)}
                        </Text>
                     </Box>
                  </Flex>

                  {/* Timestamps */}
                  <Flex justify="flex-end" mt={4}>
                     <Text color={isDark ? 'gray.500' : 'gray.500'} fontSize="sm">
                        Created on {moment(viewDetail?.createdAt).format('DD/MM/YYYY hh:mm:ss A')} By{' '}
                        {viewDetail?.createdu}
                     </Text>
                  </Flex>

                  {viewDetail?.updatedAt && viewDetail?.updatedu && (
                     <Flex justify="flex-end">
                        <Text color={isDark ? 'gray.500' : 'gray.500'} fontSize="sm" mt={2}>
                           Updated on {moment(viewDetail?.updatedAt).format('DD/MM/YYYY hh:mm:ss A')} By{' '}
                           {viewDetail?.updatedu}
                        </Text>
                     </Flex>
                  )}
               </ModalBody>

               <ModalFooter
                  bg={isDark ? 'gray.900' : 'gray.50'}
                  borderTop="2px"
                  borderColor={isDark ? 'gray.700' : 'gray.200'}
                  borderBottomRadius="2xl">
                  <Button
                     colorScheme="blue"
                     mr={3}
                     onClick={onClose}
                     _hover={{ transform: 'scale(1.05)' }}
                     className="transition-transform duration-200"
                     boxShadow="md">
                     Close
                  </Button>
               </ModalFooter>

               {/* Keep all your existing modals */}
               <IssuePurchaseEntriesModal
                  isOpen={isIssuePurchaseModalOpen}
                  onClose={() => {
                     setIsIssuePurchaseModalOpen(false);
                  }}
                  item={singleEntity}
                  subItem={selectedItem}
                  serialNo={serialNo}
                  onSave={handlesave}
                  type={
                     entityType === 'receiveinventory'
                        ? 'receive'
                        : entityType === 'issueinventory'
                           ? 'receiveissue'
                           : 'purchaseinvoice'
                  }
               />

               <LogView
                  isOpen={isShowLog}
                  onClose={onCloseLog}
                  title="Log"
                  entityType={
                     entityType === 'saleinvoice'
                        ? 'salesin'
                        : entityType === 'salereturn'
                           ? 'salesrt'
                           : entityType === 'purchaseinvoice'
                              ? 'purchasein'
                              : entityType === 'purchasert'
                                 ? 'purchaseReturn'
                                 : entityType === 'issueinventory'
                                    ? 'issue'
                                    : entityType === 'receiveinventory'
                                       ? 'receive'
                                       : entityType === 'salechallan'
                                          ? 'salesChallan'
                                          : entityType
                  }
                  id={logId}
               />

               <Modal isOpen={isBlockOpen} onClose={() => setIsBlockOpen(false)} isCentered>
                  <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
                  <ModalContent mx={4} borderRadius="xl" boxShadow="2xl">
                     <ModalHeader
                        borderBottom="1px"
                        borderColor="gray.200"
                        pb={4}
                        fontSize="xl"
                        fontWeight="600"
                     >
                        <HStack spacing={3}>
                           <Box
                              bg="red.50"
                              p={2}
                              borderRadius="lg"
                              display="inline-flex"
                           >
                              <Icon as={LockIcon} color="red.500" boxSize={5} />
                           </Box>
                           <Text>Block {selectedBlockData?.serialNo} Service</Text>
                        </HStack>
                     </ModalHeader>

                     <ModalCloseButton
                        top={4}
                        right={4}
                        borderRadius="full"
                        _hover={{ bg: 'gray.100' }}
                     />

                     <ModalBody py={6}>
                        <VStack spacing={5} align="stretch">
                           {/* Block Date Input */}
                           <FormControl>
                              <FormLabel
                                 fontSize="sm"
                                 fontWeight="600"
                                 color="gray.700"
                                 mb={2}
                              >
                                 Block Date
                              </FormLabel>
                              <Input
                                 type="date"
                                 value={blockDate}
                                 onChange={(e) => setBlockDate(e.target.value)}
                                 size="lg"
                                 borderRadius="lg"
                                 borderColor="gray.300"
                                 _hover={{ borderColor: 'gray.400' }}
                                 _focus={{
                                    borderColor: 'red.500',
                                    boxShadow: '0 0 0 1px var(--chakra-colors-red-500)'
                                 }}
                              />
                           </FormControl>

                           {/* Reason Input */}
                           <FormControl>
                              <FormLabel
                                 fontSize="sm"
                                 fontWeight="600"
                                 color="gray.700"
                                 mb={2}
                              >
                                 Reason for Blocking
                              </FormLabel>
                              <Textarea
                                 placeholder="Enter the reason for blocking this serial number..."
                                 value={blockReason}
                                 onChange={(e) => setBlockReason(e.target.value)}
                                 size="lg"
                                 borderRadius="lg"
                                 borderColor="gray.300"
                                 rows={4}
                                 resize="none"
                                 _hover={{ borderColor: 'gray.400' }}
                                 _focus={{
                                    borderColor: 'red.500',
                                    boxShadow: '0 0 0 1px var(--chakra-colors-red-500)'
                                 }}
                              />
                           </FormControl>
                        </VStack>
                     </ModalBody>

                     <ModalFooter
                        borderTop="1px"
                        borderColor="gray.200"
                        pt={4}
                        gap={3}
                     >
                        <Button
                           variant="ghost"
                           size="lg"
                           onClick={() => {
                              setIsBlockOpen(false);
                              setBlockDate('');
                              setBlockReason('');
                              setSelectedBlockData(null);
                           }}
                           _hover={{ bg: 'gray.100' }}
                        >
                           Cancel
                        </Button>

                        <Button
                           colorScheme="red"
                           size="lg"
                           onClick={handleBlock}
                           leftIcon={<Icon as={LockIcon} />}
                           px={8}
                        >
                           Block Service
                        </Button>
                     </ModalFooter>
                  </ModalContent>
               </Modal>


               <PrintBarcodeModal
                  isPrintBarcodeInfo={isPrintBarcode}
                  onClose={() => {
                     setIsPrintBarcode(false);
                     handlesave();
                  }}
                  demoformData={formData}
                  onSave={handlesave}
               />
            </ModalContent>
            {/* Recent Transactions Modal */}
            <Modal isOpen={isopenrecenttransactions} onClose={onCloserecenttransactions} size="6xl">
               <ModalOverlay backdropFilter="blur(4px)" bg={isDark ? 'blackAlpha.700' : 'blackAlpha.600'} />
               <ModalContent bg={isDark ? 'gray.800' : 'white'} boxShadow="2xl">
                  <ModalHeader
                     bg={isDark ? 'gray.900' : 'gray.50'}
                     // borderRadius="2xl"
                     borderColor={isDark ? 'gray.700' : 'gray.200'}
                     color={isDark ? 'white' : 'gray.800'}>
                     Recent Transactions ( {account?.name} )
                  </ModalHeader>
                  <ModalCloseButton color={isDark ? 'white' : 'gray.800'} />
                  <ModalBody bg={isDark ? 'gray.800' : 'white'}>
                     {isopenrecenttransactions && tableData?.length > 0 && (
                        <Box
                           // borderRadius="xl"
                           overflow="hidden"
                           borderWidth="2px"
                           borderColor={isDark ? 'gray.700' : 'gray.200'}>
                           <Table variant="simple" size="sm">
                              <Thead bg={isDark ? 'gray.900' : 'gray.100'}>
                                 <Tr>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Doc No</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Daybook Name</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>TaxableAmount</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Gst</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Net Amount</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Pending Amount</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Item Name</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Item Rate</Th>
                                    <Th color={isDark ? 'gray.300' : 'gray.700'}>Serial No</Th>
                                 </Tr>
                              </Thead>
                              <Tbody>
                                 {tableData.map((tx, index) => (
                                    <Tr
                                       key={index}
                                       _hover={{ bg: isDark ? 'gray.700' : 'gray.50' }}
                                       className="transition-colors duration-150">
                                       <Td color={isDark ? 'white' : 'gray.800'}>{tx?.docno}</Td>
                                       <Td color={isDark ? 'gray.300' : 'gray.700'}>{tx?.daybookname}</Td>
                                       <Td color={isDark ? 'gray.300' : 'gray.700'}>₹{tx?.taxableAmount}</Td>
                                       <Td color={isDark ? 'gray.300' : 'gray.700'}>₹{tx?.gstAmount}</Td>
                                       <Td color={isDark ? 'white' : 'gray.800'} fontWeight="semibold">
                                          ₹{tx?.netAmount}
                                       </Td>
                                       <Td color={isDark ? 'orange.400' : 'orange.600'} fontWeight="semibold">
                                          ₹{tx?.pendingamt}
                                       </Td>
                                       <Td color={isDark ? 'gray.300' : 'gray.700'}>
                                          {tx.lineitems?.map((item, index) => (
                                             <div key={index}>{item.itemName},</div>
                                          ))}
                                       </Td>
                                       <Td color={isDark ? 'gray.300' : 'gray.700'}>
                                          {tx.lineitems?.map((item, index) => (
                                             <div key={index}>₹{item.itemRate},</div>
                                          ))}
                                       </Td>
                                       <Td color={isDark ? 'gray.300' : 'gray.700'}>
                                          {tx.lineitems?.map((item, index) => (
                                             <div key={index}>
                                                {(entityType === 'purchaseinvoice' || entityType === 'purchasereturn'
                                                   ? item.purchaseLineDetail
                                                   : item.salesLineDetail
                                                )?.map((Lineitem, subIndex) => (
                                                   <div key={subIndex}>{Lineitem.serialNo}</div>
                                                ))}
                                             </div>
                                          ))}
                                       </Td>
                                    </Tr>
                                 ))}
                              </Tbody>
                           </Table>
                        </Box>
                     )}

                     {isopenrecenttransactions && saleInvoicesTransactions?.length === 0 && (
                        <Flex justify="center" align="center" h="200px" flexDirection="column" gap={4}>
                           <Text color={isDark ? 'gray.400' : 'gray.500'} fontSize="lg">
                              No transactions found.
                           </Text>
                        </Flex>
                     )}
                  </ModalBody>

                  <ModalFooter
                     bg={isDark ? 'gray.900' : 'gray.50'}
                     // borderTop="2px"
                     borderColor={isDark ? 'gray.700' : 'gray.200'}>
                     <Button
                        colorScheme="blue"
                        mr={3}
                        onClick={onCloserecenttransactions}
                        _hover={{ transform: 'scale(1.05)' }}
                        className="transition-transform duration-200">
                        Close
                     </Button>
                  </ModalFooter>
               </ModalContent>
            </Modal>
         </Modal>

         {/* Setup Format Modal */}
         <Modal
            isOpen={isViewSetupFormatModalOpen || shouldOpenModalForWpSettings || shouldOpenModalForCashBank}
            onClose={() => {
               onViewCloseSetupFormatModal();
               setViewSetupFormat({});
               handleClick();
            }}
            size="xl">
            <ModalOverlay backdropFilter="blur(4px)" bg={isDark ? 'blackAlpha.700' : 'blackAlpha.600'} />
            <ModalContent bg={isDark ? 'gray.800' : 'white'} borderRadius="2xl" boxShadow="2xl">
               <ModalHeader
                  bg={isDark ? 'gray.900' : 'gray.50'}
                  borderTopRadius="2xl"
                  borderBottom="2px"
                  borderColor={isDark ? 'gray.700' : 'gray.200'}
                  color={isDark ? 'white' : 'gray.800'}>
                  Setup Format
                  {shouldOpenModalForWpSettings && (
                     <Badge ml={2} colorScheme="green" fontSize="sm">
                        WhatsApp Setting Required
                     </Badge>
                  )}
               </ModalHeader>
               <ModalCloseButton color={isDark ? 'white' : 'gray.800'} />
               <ModalBody bg={isDark ? 'gray.800' : 'white'}>
                  {Array.isArray(setupFormat) && setupFormat.length > 0 ? (
                     setupFormat.map((format, index) => (
                        <Box
                           key={index}
                           border={
                              selectedFormat?.id === format.id
                                 ? '2px solid'
                                 : format.isDefault
                                    ? '2px solid'
                                    : '2px solid'
                           }
                           borderColor={
                              selectedFormat?.id === format.id
                                 ? isDark
                                    ? 'blue.500'
                                    : 'blue.400'
                                 : format.isDefault
                                    ? isDark
                                       ? 'green.500'
                                       : 'green.400'
                                    : isDark
                                       ? 'gray.700'
                                       : 'gray.200'
                           }
                           backgroundColor={
                              selectedFormat?.id === format.id
                                 ? isDark
                                    ? 'blue.900'
                                    : 'blue.50'
                                 : format.isDefault
                                    ? isDark
                                       ? 'green.900'
                                       : 'green.50'
                                    : focusIndex === index
                                       ? isDark
                                          ? 'gray.700'
                                          : 'gray.100'
                                       : isDark
                                          ? 'gray.800'
                                          : 'white'
                           }
                           p={4}
                           borderRadius="xl"
                           mb={3}
                           position="relative"
                           cursor="pointer"
                           onClick={() => setSelectedFormat(format)}
                           _hover={{
                              transform: 'scale(1.02)',
                              boxShadow: 'lg',
                           }}
                           className="transition-all duration-200"
                           ref={(el) => (setupFormatRef.current[index] = el)}
                           tabIndex={0}
                           onKeyDown={(e) => {
                              if (e.key === 'ArrowDown' || (e.key === 'Tab' && !e.shiftKey)) {
                                 e.preventDefault();
                                 const nextIndex = (index + 1) % setupFormatRef.current.length;
                                 setupFormatRef.current[nextIndex]?.focus();
                              } else if (e.key === 'ArrowUp' || (e.key === 'Tab' && e.shiftKey)) {
                                 e.preventDefault();
                                 const prevIndex =
                                    (index - 1 + setupFormatRef.current.length) % setupFormatRef.current.length;
                                 setupFormatRef.current[prevIndex]?.focus();
                              } else if (e.key === 'Enter') {
                                 setSelectedFormat(format);
                                 PrintRef.current?.focus();
                              }
                           }}>
                           <Flex justify="space-between" align="start">
                              <Box>
                                 <Text fontWeight="bold" fontSize="lg" color={isDark ? 'white' : 'gray.800'}>
                                    {format.name || format.PrintFormat?.Name || 'Unnamed Format'}
                                 </Text>
                                 {format.isDefault && (
                                    <Badge colorScheme="green" mt={2} fontSize="sm">
                                       ✅ Default Format
                                    </Badge>
                                 )}
                                 {selectedFormat?.id === format.id && (
                                    <Badge colorScheme="blue" mt={2} fontSize="sm">
                                       🔵 Selected Format
                                    </Badge>
                                 )}
                              </Box>
                           </Flex>
                        </Box>
                     ))
                  ) : (
                     <Flex justify="center" align="center" h="150px" flexDirection="column">
                        <Text color={isDark ? 'gray.400' : 'gray.500'}>No setup formats available.</Text>
                     </Flex>
                  )}
               </ModalBody>
               <ModalFooter
                  bg={isDark ? 'gray.900' : 'gray.50'}
                  borderTop="2px"
                  borderColor={isDark ? 'gray.700' : 'gray.200'}
                  borderBottomRadius="2xl"
                  gap={2}>
                  <Box
                     cursor={selectedFormat ? 'pointer' : 'not-allowed'}
                     onClick={() => {
                        if (selectedFormat) {
                           if (!account?.mobile && !DaybookMobile) {
                              setIsModalOpen(true);
                           } else {
                              shareToWhatsApp(selectedFormat, false, 'email');
                           }
                        }
                     }}
                     opacity={isProcessingEmail ? 0.6 : selectedFormat ? 1 : 0.4}
                     display="flex"
                     alignItems="center"
                     gap="2"
                     p={2}
                     borderRadius="lg"
                     _hover={selectedFormat ? { bg: isDark ? 'gray.700' : 'gray.100' } : {}}
                     className="transition-all duration-200">
                     <MdEmail size={27} color={isDark ? '#48BB78' : 'green'} />
                     {isProcessingEmail && <Text color={isDark ? 'gray.300' : 'gray.700'}>Sending...</Text>}
                  </Box>
                  <Box
                     cursor={selectedFormat ? 'pointer' : 'not-allowed'}
                     onClick={() => {
                        if (selectedFormat) {
                           // localAccount?.mobile और DaybookMobile check करें
                           if (!localAccount?.mobile && !DaybookMobile) {
                              setIsModalOpen(true);
                           } else {
                              shareToWhatsApp(selectedFormat, false, 'wp');
                           }
                        }
                     }}
                     opacity={isProcessingWp ? 0.6 : selectedFormat ? 1 : 0.4}
                     display="flex"
                     alignItems="center"
                     gap="2"
                     p={2}
                     borderRadius="lg"
                     _hover={selectedFormat ? { bg: isDark ? 'gray.700' : 'gray.100' } : {}}
                     className="transition-all duration-200">
                     <FaWhatsappSquare size={27} color={isDark ? '#48BB78' : 'green'} />
                     {isProcessingWp && <Text color={isDark ? 'gray.300' : 'gray.700'}>Sending...</Text>}
                  </Box>
                  <Button
                     colorScheme="blue"
                     variant="outline"
                     onClick={() => {
                        onViewCloseSetupFormatModal();
                        setViewSetupFormat({});
                        handleClick();
                     }}
                     _hover={{ transform: 'scale(1.05)' }}
                     className="transition-transform duration-200">
                     Close
                  </Button>
                  <Button
                     colorScheme="green"
                     onClick={async () => {
                        if (selectedFormat) {
                           await handlePrintWithSelectedFormat(selectedFormat, 'export');
                           setViewSetupFormat({});
                        }
                     }}
                     isDisabled={!selectedFormat}
                     _hover={{ transform: 'scale(1.05)' }}
                     className="transition-transform duration-200">
                     Preview
                  </Button>
                  <Button
                     ref={PrintRef}
                     colorScheme="orange"
                     onClick={async () => {
                        if (selectedFormat) {
                           await handleDirectPDFExport(selectedFormat, 'print');
                           onViewCloseSetupFormatModal();
                           setViewSetupFormat({});
                           handleClick();
                        }
                     }}
                     isDisabled={!selectedFormat}
                     isLoading={isGenerating}
                     _hover={{ transform: 'scale(1.05)' }}
                     className="transition-transform duration-200">
                     🖨️ Print
                  </Button>
                  <Button
                     colorScheme="purple"
                     onClick={async () => {
                        if (selectedFormat) {
                           await handleDirectPDFExport(selectedFormat);
                           onViewCloseSetupFormatModal();
                           setViewSetupFormat({});
                           handleClick();
                        }
                     }}
                     isDisabled={!selectedFormat}
                     isLoading={isGenerating}
                     _hover={{ transform: 'scale(1.05)' }}
                     className="transition-transform duration-200">
                     PDF Export
                  </Button>
               </ModalFooter>
            </ModalContent>
         </Modal>

         {/* Preview Modal */}
         <Modal isOpen={isPreviewOpen} onClose={onClosePreview} size="12xl">
            <ModalOverlay backdropFilter="blur(4px)" bg={isDark ? 'blackAlpha.700' : 'blackAlpha.600'} />
            <ModalContent maxW="100vw" maxH="100vh" bg={isDark ? 'gray.800' : 'white'}>
               <ModalHeader
                  bg={isDark ? 'gray.900' : 'gray.50'}
                  borderBottom="2px"
                  borderColor={isDark ? 'gray.700' : 'gray.200'}
                  color={isDark ? 'white' : 'gray.800'}>
                  <Flex>
                     <Box>Invoice Preview</Box>
                     <Spacer />
                     <Button
                        colorScheme="blue"
                        mr={10}
                        onClick={generatePDF}
                        isLoading={isGenerating}
                        _hover={{ transform: 'scale(1.05)' }}
                        className="transition-transform duration-200">
                        PDF Export
                     </Button>
                  </Flex>
               </ModalHeader>
               <ModalCloseButton color={isDark ? 'white' : 'gray.800'} />
               <ModalBody bg={isDark ? 'gray.700' : 'gray.100'} p={8}>
                  <Box
                     width={`${getPageWidth(previewElements)}px`}
                     height={`${getPageHeight(previewElements)}px`}
                     bg="white"
                     border="2px solid"
                     borderColor={isDark ? 'gray.600' : 'gray.300'}
                     mx="auto"
                     position="relative"
                     overflow="hidden"
                     boxShadow="2xl"
                     borderRadius="lg">
                     {previewElements &&
                        previewElements?.elements &&
                        previewElements?.elements?.map((element) => renderElement(element, true, setupFormat))}
                  </Box>
               </ModalBody>
               <ModalFooter
                  bg={isDark ? 'gray.900' : 'gray.50'}
                  borderTop="2px"
                  borderColor={isDark ? 'gray.700' : 'gray.200'}>
                  <Button
                     colorScheme="blue"
                     mr={3}
                     onClick={generatePDF}
                     isLoading={isGenerating}
                     _hover={{ transform: 'scale(1.05)' }}
                     className="transition-transform duration-200">
                     Export PDF
                  </Button>
                  <Button
                     onClick={() => onClosePreview()}
                     variant="outline"
                     _hover={{ transform: 'scale(1.05)' }}
                     className="transition-transform duration-200">
                     Close
                  </Button>
               </ModalFooter>
            </ModalContent>
         </Modal>

         {/* Mobile No Form Modal */}
         {!localAccount?.mobile && !DaybookMobile && (
            <MobileNoForm
               isOpen={isModalOpen}
               onClose={() => setIsModalOpen(false)}
               accountId={localAccount?.id}
               glGroupId={localAccount?.glGroupId}
               name={localAccount?.name}
               shareToWhatsApp={() => shareToWhatsApp(null, false, 'wp')}
               isProcessingWp={isProcessingWp}
               setIsProcessingWp={setIsProcessingWp}
               onSuccess={(updatedMobile) => {
                  // Local state update करें
                  setLocalAccount((prev) => ({
                     ...prev,
                     mobile: updatedMobile,
                  }));
               }}
            />
         )}

         {/* Return Modal */}
         <Modal isOpen={isOpenReturn} onClose={onCloseReturn} isCentered>
            <ModalOverlay bg={isDark ? 'blackAlpha.700' : 'blackAlpha.600'} />
            <ModalContent bg="transparent" borderRadius="2xl" boxShadow="none" className="overflow-hidden">
               {/* Header */}
               <div
                  className={`flex items-center justify-between px-6 py-4 ${isDark
                     ? 'bg-gradient-to-r from-slate-800 to-slate-900 border-b border-slate-700'
                     : 'bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-200'
                     }`}>
                  <div className="flex items-center gap-3">
                     <div
                        className={`w-10 h-10 rounded-lg flex items-center justify-center ${isDark ? 'bg-blue-500/20' : 'bg-blue-500/10'
                           }`}>
                        <svg
                           className={isDark ? 'text-blue-400' : 'text-blue-600'}
                           width="24"
                           height="24"
                           viewBox="0 0 24 24"
                           fill="none"
                           stroke="currentColor"
                           strokeWidth="2">
                           <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                           <polyline points="7.5 4.21 12 6.81 16.5 4.21" />
                           <polyline points="7.5 19.79 7.5 14.6 3 12" />
                           <polyline points="21 12 16.5 14.6 16.5 19.79" />
                           <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                           <line x1="12" y1="22.08" x2="12" y2="12" />
                        </svg>
                     </div>
                     <h2 className={`text-xl font-semibold ${isDark ? 'text-white' : 'text-gray-800'}`}>Add Return</h2>
                  </div>
                  <button
                     onClick={onCloseReturn}
                     className={`w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-200 ${isDark
                        ? 'text-gray-400 hover:text-white hover:bg-slate-700'
                        : 'text-gray-500 hover:text-gray-800 hover:bg-gray-200'
                        }`}>
                     <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M15 5L5 15M5 5l10 10" />
                     </svg>
                  </button>
               </div>

               {/* Body */}
               <div className={`px-6 py-8 ${isDark ? 'bg-slate-800' : 'bg-white'}`}>
                  <div className="space-y-6">
                     {/* Return Reason */}
                     <div className="space-y-2">
                        <label className={`block text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                           Return Reason
                        </label>
                        <input
                           type="text"
                           placeholder="Enter reason for return"
                           value={reason}
                           onChange={(e) => setReason(e.target.value)}
                           className={`w-full px-4 py-3 rounded-xl border-2 transition-all duration-200 focus:outline-none ${isDark
                              ? 'bg-slate-900/50 border-slate-700 text-white placeholder-gray-500 hover:border-slate-600 focus:border-blue-500 focus:bg-slate-900'
                              : 'bg-gray-50 border-gray-200 text-gray-800 placeholder-gray-400 hover:border-gray-300 focus:border-blue-400 focus:bg-white'
                              }`}
                        />
                     </div>

                     {/* Return Date */}
                     <div className="space-y-2">
                        <label className={`block text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                           Return Date
                        </label>
                        <div className="relative">
                           <div
                              className={`absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none ${isDark ? 'text-gray-500' : 'text-gray-400'
                                 }`}>
                              <svg
                                 width="20"
                                 height="20"
                                 viewBox="0 0 20 20"
                                 fill="none"
                                 stroke="currentColor"
                                 strokeWidth="2">
                                 <rect x="3" y="4" width="14" height="14" rx="2" ry="2" />
                                 <line x1="3" y1="9" x2="17" y2="9" />
                                 <line x1="10" y1="4" x2="10" y2="2" />
                              </svg>
                           </div>
                           <input
                              type="date"
                              placeholder="dd-mm-yyyy"
                              value={returnDate}
                              onChange={(e) => setReturnDate(e.target.value)}
                              className={`w-full pl-12 pr-4 py-3 rounded-xl border-2 transition-all duration-200 focus:outline-none ${isDark
                                 ? 'bg-slate-900/50 border-slate-700 text-white hover:border-slate-600 focus:border-blue-500 focus:bg-slate-900 [color-scheme:dark]'
                                 : 'bg-gray-50 border-gray-200 text-gray-800 hover:border-gray-300 focus:border-blue-400 focus:bg-white'
                                 }`}
                           />
                        </div>
                     </div>
                  </div>
               </div>

               {/* Footer */}
               <div
                  className={`flex items-center justify-end gap-3 px-6 py-4 ${isDark ? 'bg-slate-900 border-t border-slate-700' : 'bg-gray-50 border-t border-gray-200'
                     }`}>
                  <button
                     onClick={onCloseReturn}
                     className={`px-6 py-2.5 rounded-lg font-medium transition-all duration-200 ${isDark
                        ? 'text-gray-300 bg-slate-800 hover:bg-slate-700 border-2 border-slate-700 hover:border-slate-600'
                        : 'text-gray-700 bg-white hover:bg-gray-50 border-2 border-gray-300 hover:border-gray-400'
                        }`}>
                     Cancel
                  </button>
                  <button
                     onClick={saveReason}
                     className={`px-6 py-2.5 rounded-lg font-medium transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105 ${isDark ? 'text-white bg-blue-600 hover:bg-blue-700' : 'text-white bg-blue-600 hover:bg-blue-700'
                        }`}>
                     Save Return
                  </button>
               </div>
            </ModalContent>
         </Modal>
      </>
   );
};
export default SalesDetails;
